import gql from 'graphql-tag';
import * as ApolloReactCommon from '@apollo/react-common';
import * as ApolloReactHooks from '@apollo/react-hooks';
export type Maybe<T> = T | null;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** The javascript `Date` as string. Type represents date and time as the ISO Date string. */
  DateTime: any;
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: any;
  /** The `Upload` scalar type represents a file upload. */
  Upload: any;
};

export type AccountConfigEntity = AuditEntity & {
  __typename?: 'AccountConfigEntity';
  createdTs: Scalars['DateTime'];
  createdBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  modBy?: Maybe<Scalars['String']>;
  ID: Scalars['String'];
  accessTokenDuration: Scalars['String'];
  refreshTokenDuration: Scalars['String'];
  accountID: Scalars['String'];
  pwdchangefrequency: Scalars['Float'];
  repeatPwd: Scalars['Float'];
};

export type AccountDeleteInput = {
  ID: Scalars['String'];
};

export type AccountEntity = AuditEntity & {
  __typename?: 'AccountEntity';
  createdTs: Scalars['DateTime'];
  createdBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  modBy?: Maybe<Scalars['String']>;
  ID: Scalars['String'];
  name: Scalars['String'];
  code: Scalars['String'];
  regNo?: Maybe<Scalars['String']>;
  contactNo: Scalars['String'];
  email: Scalars['String'];
  currencyID?: Maybe<Scalars['String']>;
  address?: Maybe<Address>;
  isInternal: Scalars['Boolean'];
  contactPerson?: Maybe<Array<ContactPerson>>;
  image?: Maybe<Scalars['String']>;
  imageUrl?: Maybe<Scalars['String']>;
  imageBucketFile?: Maybe<Scalars['String']>;
  commonStatus: CommonStatus;
  subscription: Array<SubscriptionEntity>;
  termsConditions: Array<TermsConditionsEntity>;
  bankAccount: Array<FromBankAccountEntity>;
  currency?: Maybe<CurrencyNoteEntity>;
  roleAccount?: Maybe<Array<RoleAccountEntity>>;
  softwareSubscription: SubscriptionEntity;
  latestSubscription: Scalars['JSON'];
};


export type AccountEntitySoftwareSubscriptionArgs = {
  softwareCode: Scalars['String'];
};


export type AccountEntityLatestSubscriptionArgs = {
  softwareCode: Scalars['String'];
};

export type AccountInput = {
  ID?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  code: Scalars['String'];
  email: Scalars['String'];
  regNo: Scalars['String'];
  contactNo: Scalars['String'];
  softwareCode?: Maybe<Scalars['String']>;
  address?: Maybe<AddressInput>;
  contactPerson?: Maybe<Array<ContactPersonInput>>;
  currencyID?: Maybe<Scalars['String']>;
  commonStatus?: Maybe<CommonStatus>;
  isInternal?: Maybe<Scalars['Boolean']>;
  image?: Maybe<Scalars['String']>;
  imageUrl?: Maybe<Scalars['String']>;
  imageBucketFile?: Maybe<Scalars['String']>;
  file?: Maybe<Array<Scalars['Upload']>>;
};

export enum AccountPackage {
  WorkDesk = 'WORK_DESK',
  GeneralLedger = 'GENERAL_LEDGER',
  CashBook = 'CASH_BOOK',
  AccountReceivable = 'ACCOUNT_RECEIVABLE',
  AccountPayable = 'ACCOUNT_PAYABLE',
  InventoryControl = 'INVENTORY_CONTROL',
  GeneralPurchases = 'GENERAL_PURCHASES',
  Einvoice = 'EINVOICE'
}

/** JsonType */
export type Address = {
  __typename?: 'Address';
  ID?: Maybe<Scalars['String']>;
  address?: Maybe<Scalars['String']>;
  address2?: Maybe<Scalars['String']>;
  siteName?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  district?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  postCode?: Maybe<Scalars['String']>;
  postCodeName?: Maybe<Scalars['String']>;
  AddressType?: Maybe<AddressType>;
};

export type AddressInput = {
  ID?: Maybe<Scalars['String']>;
  address?: Maybe<Scalars['String']>;
  address2?: Maybe<Scalars['String']>;
  siteName?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  district?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  postCode?: Maybe<Scalars['String']>;
  postCodeName?: Maybe<Scalars['String']>;
  AddressType?: Maybe<AddressType>;
};

export enum AddressType {
  Primary = 'PRIMARY',
  Delivery = 'DELIVERY',
  Site = 'SITE'
}

export type AllStandardCoreBaseEntity = StandardAuditEntity & {
  __typename?: 'AllStandardCoreBaseEntity';
  createdTs: Scalars['DateTime'];
  createdBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  modBy?: Maybe<Scalars['String']>;
  ID: Scalars['String'];
};

export type AllowedOriginDeleteInput = {
  ID: Scalars['String'];
};

export type AllowedOriginEntity = AuditEntity & {
  __typename?: 'AllowedOriginEntity';
  createdTs: Scalars['DateTime'];
  createdBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  modBy?: Maybe<Scalars['String']>;
  ID: Scalars['String'];
  productID: Scalars['String'];
  origin: Scalars['String'];
  description: Scalars['String'];
  commonStatus: CommonStatus;
  product: ProductEntity;
};

export type AllowedOriginInput = {
  ID?: Maybe<Scalars['String']>;
  productID?: Maybe<Scalars['String']>;
  origin: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  commonStatus: CommonStatus;
};

export type AttachmentData = {
  __typename?: 'AttachmentData';
  content: Scalars['String'];
  filename: Scalars['String'];
};

export type AttachmentEntity = AuditEntity & {
  __typename?: 'AttachmentEntity';
  createdTs: Scalars['DateTime'];
  createdBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  modBy?: Maybe<Scalars['String']>;
  ID: Scalars['String'];
  mediaType: Scalars['String'];
  refTable: Scalars['String'];
  refID?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  fileName?: Maybe<Scalars['String']>;
  fileURL?: Maybe<Scalars['String']>;
  accountID: Scalars['String'];
  bucketFileName?: Maybe<Scalars['String']>;
  opacity?: Maybe<Scalars['String']>;
  isPrivate: Scalars['Boolean'];
  folderExist: Scalars['Boolean'];
  commonStatus: CommonStatus;
  account: AccountEntity;
};

export type AttachmentInput = {
  description: Scalars['String'];
  refTable: Scalars['String'];
  refID: Scalars['String'];
  file: Array<Scalars['Upload']>;
};

export type AuditEntity = {
  createdTs: Scalars['DateTime'];
  createdBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  modBy?: Maybe<Scalars['String']>;
};

export type AzureStorageOutput = {
  __typename?: 'AzureStorageOutput';
  BucketFileName: Scalars['String'];
  FileName: Scalars['String'];
  Url: Scalars['String'];
  MediaType: Scalars['String'];
  IsPrivate?: Maybe<Scalars['Boolean']>;
  PrivateUrl?: Maybe<Scalars['String']>;
};

export type BankAccountEntity = AuditEntity & {
  __typename?: 'BankAccountEntity';
  createdTs: Scalars['DateTime'];
  createdBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  modBy?: Maybe<Scalars['String']>;
  ID: Scalars['String'];
  accountID: Scalars['String'];
  companyID: Scalars['String'];
  company?: Maybe<CompanyEntity>;
  bankProfileID: Scalars['String'];
  bankProfile?: Maybe<BankProfileEntity>;
  currencyID?: Maybe<Scalars['String']>;
  currency: CurrencyEntity;
  masterCOAID?: Maybe<Scalars['String']>;
  glAccountCode?: Maybe<Scalars['String']>;
  code: Scalars['String'];
  accountNo: Scalars['String'];
  effectiveDate: Scalars['String'];
  accountHolder?: Maybe<Scalars['String']>;
  branchCode?: Maybe<Scalars['String']>;
  swiftCode?: Maybe<Scalars['String']>;
  bankClearance?: Maybe<Scalars['String']>;
  isSecurityCash?: Maybe<Scalars['Boolean']>;
  isKeyCardCash?: Maybe<Scalars['Boolean']>;
  isCash?: Maybe<Scalars['Boolean']>;
  q3RevenueMapping?: Maybe<Array<Scalars['JSON']>>;
  type: BankAccountType;
  commonStatus: CommonStatus;
};

export enum BankAccountType {
  Cash = 'CASH',
  Bank = 'BANK'
}

export type BankProfileEntity = AuditEntity & {
  __typename?: 'BankProfileEntity';
  createdTs: Scalars['DateTime'];
  createdBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  modBy?: Maybe<Scalars['String']>;
  ID: Scalars['String'];
  accountID: Scalars['String'];
  name: Scalars['String'];
  address: Scalars['JSON'];
  contactNo?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  contactPerson?: Maybe<Array<Scalars['JSON']>>;
  commonStatus: CommonStatus;
  bankAccount?: Maybe<Array<BankAccountEntity>>;
};

export type BaseInput = {
  ID?: Maybe<Scalars['String']>;
  createdBy?: Maybe<Scalars['String']>;
  commonStatus?: Maybe<CommonStatus>;
};

export type CityEntity = AuditEntity & {
  __typename?: 'CityEntity';
  createdTs: Scalars['DateTime'];
  createdBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  modBy?: Maybe<Scalars['String']>;
  ID: Scalars['String'];
  name: Scalars['String'];
  stateID: Scalars['String'];
  state: StateEntity;
  commonStatus: CommonStatus;
  district: Array<DistrictEntity>;
  postcode: Array<PostcodeEntity>;
};

export type CityInput = {
  name?: Maybe<Scalars['String']>;
  stateID?: Maybe<Scalars['String']>;
  ID?: Maybe<Scalars['String']>;
};

export enum CommonStatus {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE',
  Block = 'BLOCK'
}

export type CompanyEntity = AuditEntity & {
  __typename?: 'CompanyEntity';
  createdTs: Scalars['DateTime'];
  createdBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  modBy?: Maybe<Scalars['String']>;
  CompanyID: Scalars['String'];
  AccountID: Scalars['String'];
  ParentCompanyID?: Maybe<Scalars['String']>;
  BaseCurrencyID: Scalars['String'];
  Currency: CurrencyEntity;
  Name: Scalars['String'];
  Description?: Maybe<Scalars['String']>;
  CompanyRegNo: Scalars['String'];
  Code?: Maybe<Scalars['String']>;
  Address?: Maybe<Address>;
  ContactNo?: Maybe<Scalars['String']>;
  OfficeTel?: Maybe<Scalars['String']>;
  Email?: Maybe<Scalars['String']>;
  SSTNo?: Maybe<Scalars['String']>;
  GSTNo?: Maybe<Scalars['String']>;
  GSTExpiryDate?: Maybe<Scalars['String']>;
  GroupGSTRegNo?: Maybe<Scalars['String']>;
  Image?: Maybe<Scalars['String']>;
  ImageUrl?: Maybe<Scalars['String']>;
  ImageBucketFile?: Maybe<Scalars['String']>;
  WebsiteUrl?: Maybe<Scalars['String']>;
  RegionID?: Maybe<Scalars['String']>;
  ImageLogoPosition?: Maybe<Scalars['String']>;
  WatermarkImplementation: Scalars['Boolean'];
  WatermarkWording?: Maybe<Scalars['String']>;
  IsoImplementation: Scalars['Boolean'];
  IsoLogoPosition?: Maybe<Scalars['String']>;
  CompanyTax: CompanyTax;
  TourismTaxNo?: Maybe<Scalars['String']>;
  Tin?: Maybe<Scalars['String']>;
  eSign?: Maybe<Scalars['String']>;
  eSignExpiryDate?: Maybe<Scalars['DateTime']>;
  eInvIntegrated: Scalars['Boolean'];
  eInvStartDate?: Maybe<Scalars['String']>;
  eInvEndDate?: Maybe<Scalars['String']>;
  eInvClientID?: Maybe<Scalars['String']>;
  eInvClientSecret?: Maybe<Scalars['String']>;
  eInvClientSecret2?: Maybe<Scalars['String']>;
  RecordStatus: Scalars['String'];
  companyMsicAssignment: Array<CompanyMsicAssignmentEntity>;
  bankAccount: Array<BankAccountEntity>;
};

export type CompanyMsicAssignmentEntity = AuditEntity & {
  __typename?: 'CompanyMsicAssignmentEntity';
  createdTs: Scalars['DateTime'];
  createdBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  modBy?: Maybe<Scalars['String']>;
  ID: Scalars['String'];
  accountID: Scalars['String'];
  companyID: Scalars['String'];
  company?: Maybe<CompanyEntity>;
  eInvoiceMsicCodeID: Scalars['String'];
  eInvoiceMsicCode?: Maybe<EInvoiceMsicEntity>;
  isDefault: Scalars['Boolean'];
};

export enum CompanyTax {
  NoTax = 'NO_TAX',
  SstNo = 'SST_NO',
  GstNo = 'GST_NO'
}

/** JsonType */
export type ContactPerson = {
  __typename?: 'ContactPerson';
  ID?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  associateID?: Maybe<Scalars['String']>;
  docRefTable?: Maybe<Scalars['String']>;
  designation?: Maybe<Scalars['String']>;
  contactNo?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
};

export type ContactPersonInput = {
  ID?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  associateID?: Maybe<Scalars['String']>;
  docRefTable?: Maybe<Scalars['String']>;
  designation?: Maybe<Scalars['String']>;
  contactNo?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
};

export enum ContractPackage {
  WorkDesk = 'WORK_DESK',
  BillOfQuantities = 'BILL_OF_QUANTITIES',
  WorkBreakdownStructure = 'WORK_BREAKDOWN_STRUCTURE',
  ContractManagement = 'CONTRACT_MANAGEMENT',
  ClientAccount = 'CLIENT_ACCOUNT',
  DefectManagement = 'DEFECT_MANAGEMENT',
  PlantMachinery = 'PLANT_MACHINERY',
  ProjectPurchase = 'PROJECT_PURCHASE',
  ProjectCosting = 'PROJECT_COSTING',
  SubconTender = 'SUBCON_TENDER',
  SubcontractManagement = 'SUBCONTRACT_MANAGEMENT',
  SubcontractorAccount = 'SUBCONTRACTOR_ACCOUNT',
  SupplierAccount = 'SUPPLIER_ACCOUNT',
  SystemAdmin = 'SYSTEM_ADMIN',
  SiteAttendance = 'SITE_ATTENDANCE',
  SiteInventory = 'SITE_INVENTORY',
  SiteSurveillance = 'SITE_SURVEILLANCE',
  SiteWages = 'SITE_WAGES',
  Einvoice = 'EINVOICE'
}

export type CoreBaseEntity = AuditEntity & {
  __typename?: 'CoreBaseEntity';
  createdTs: Scalars['DateTime'];
  createdBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  modBy?: Maybe<Scalars['String']>;
  ID: Scalars['String'];
};

export type CountryEntity = AuditEntity & {
  __typename?: 'CountryEntity';
  createdTs: Scalars['DateTime'];
  createdBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  modBy?: Maybe<Scalars['String']>;
  ID: Scalars['String'];
  name: Scalars['String'];
  code: Scalars['String'];
  eInvCode: Scalars['String'];
  commonStatus: CommonStatus;
  state: Array<StateEntity>;
};

export type CountryInput = {
  name?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['String']>;
  ID?: Maybe<Scalars['String']>;
};

export type CreateAuditInput = {
  createdBy?: Maybe<Scalars['String']>;
};

export type CurrencyDeleteInput = {
  ID: Scalars['String'];
};

export type CurrencyEntity = AuditEntity & {
  __typename?: 'CurrencyEntity';
  createdTs: Scalars['DateTime'];
  createdBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  modBy?: Maybe<Scalars['String']>;
  ID: Scalars['String'];
  name: Scalars['String'];
  code: Scalars['String'];
  symbol: Scalars['String'];
  format: NumericFormatter;
  commonStatus: CommonStatus;
  company: Array<CompanyEntity>;
  bankAccount: Array<BankAccountEntity>;
};

export type CurrencyExchangeEntity = AuditEntity & {
  __typename?: 'CurrencyExchangeEntity';
  createdTs: Scalars['DateTime'];
  createdBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  modBy?: Maybe<Scalars['String']>;
  ID: Scalars['String'];
  fromCurrencyID: Scalars['String'];
  toCurrencyID: Scalars['String'];
  effectiveDate: Scalars['DateTime'];
  fromAmt: Scalars['Float'];
  toAmt: Scalars['Float'];
  exchangeRate: Scalars['Float'];
  commonStatus: CommonStatus;
};

export type CurrencyInput = {
  ID?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  symbol?: Maybe<Scalars['String']>;
  commonStatus?: Maybe<CommonStatus>;
};

export type CurrencyNoteEntity = AuditEntity & {
  __typename?: 'CurrencyNoteEntity';
  createdTs: Scalars['DateTime'];
  createdBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  modBy?: Maybe<Scalars['String']>;
  ID: Scalars['String'];
  code: Scalars['String'];
  name: Scalars['String'];
  symbol: Scalars['String'];
  commonStatus: CommonStatus;
  account?: Maybe<Array<AccountEntity>>;
};


export type DistrictEntity = AuditEntity & {
  __typename?: 'DistrictEntity';
  createdTs: Scalars['DateTime'];
  createdBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  modBy?: Maybe<Scalars['String']>;
  ID: Scalars['String'];
  name: Scalars['String'];
  cityID: Scalars['String'];
  city: CityEntity;
  commonStatus: CommonStatus;
};

export type DistrictInput = {
  name?: Maybe<Scalars['String']>;
  cityID?: Maybe<Scalars['String']>;
  ID?: Maybe<Scalars['String']>;
};

export type DownloadLogEntity = AuditEntity & {
  __typename?: 'DownloadLogEntity';
  createdTs: Scalars['DateTime'];
  createdBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  modBy?: Maybe<Scalars['String']>;
  ID: Scalars['String'];
  accountID: Scalars['String'];
  softwareName: Scalars['String'];
  attachmentID?: Maybe<Scalars['String']>;
  fileName: Scalars['String'];
  fileSize: Scalars['Float'];
  modulePath?: Maybe<Scalars['String']>;
  ipAddress?: Maybe<Scalars['String']>;
  commonStatus: CommonStatus;
};

export type DownloadLogInput = {
  accountID: Scalars['String'];
  softwareName: Scalars['String'];
  attachmentID?: Maybe<Scalars['String']>;
  fileName: Scalars['String'];
  fileSize: Scalars['Float'];
  modulePath?: Maybe<Scalars['String']>;
  ipAddress?: Maybe<Scalars['String']>;
};

export enum EinvoicePackages {
  Outbound = 'OUTBOUND',
  Inbound = 'INBOUND'
}

export type EmailBlastArgs = {
  __typename?: 'EmailBlastArgs';
  senderName: Scalars['String'];
  senderEmail: Scalars['String'];
  recipients: Array<Scalars['String']>;
  subject: Scalars['String'];
  message: Scalars['String'];
  isMultiple: Scalars['Boolean'];
  ccEmail?: Maybe<Array<Scalars['String']>>;
  bccEmail?: Maybe<Array<Scalars['String']>>;
  categories?: Maybe<Array<Scalars['String']>>;
  attachments?: Maybe<Array<AttachmentData>>;
  replyTo?: Maybe<Scalars['String']>;
  sentAt?: Maybe<Scalars['Float']>;
};

export type EmailBlastAttachment = {
  content: Scalars['String'];
  filename: Scalars['String'];
};

export type EmailBlastInput = {
  senderName: Scalars['String'];
  recipients: Array<Scalars['String']>;
  subject: Scalars['String'];
  message: Scalars['String'];
  isMultiple: Scalars['Boolean'];
  ccEmail?: Maybe<Array<Scalars['String']>>;
  bccEmail?: Maybe<Array<Scalars['String']>>;
  attachments?: Maybe<Array<EmailBlastAttachment>>;
  categories?: Maybe<Array<Scalars['String']>>;
  replyTo?: Maybe<Scalars['String']>;
  sendAtUnix?: Maybe<Scalars['Float']>;
};

export type EmailBlastLogEntity = AuditEntity & {
  __typename?: 'EmailBlastLogEntity';
  createdTs: Scalars['DateTime'];
  createdBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  modBy?: Maybe<Scalars['String']>;
  ID: Scalars['String'];
  commonStatus: Scalars['String'];
  accountId: Scalars['String'];
  softwareId: Scalars['String'];
  softwareCode: Scalars['String'];
  args?: Maybe<EmailBlastArgs>;
  recipientCount: Scalars['Float'];
  errorMsg?: Maybe<Scalars['String']>;
};

/** JsonType */
export type EntityControl = {
  __typename?: 'EntityControl';
  noOfEntity?: Maybe<Scalars['Float']>;
  noofExtraEntity?: Maybe<Scalars['Float']>;
};

export type EntityControlInput = {
  noOfEntity?: Maybe<Scalars['Float']>;
  noofExtraEntity?: Maybe<Scalars['Float']>;
};

/** JsonType */
export type EnvironmentUrl = {
  __typename?: 'EnvironmentUrl';
  environment?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

export type EnvironmentUrlInput = {
  environment?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

export enum EventPackage {
  EventManagement = 'EVENT_MANAGEMENT',
  Einvoice = 'EINVOICE'
}

export type ExchangeLog = {
  __typename?: 'ExchangeLog';
  exchangeRate?: Maybe<Scalars['Float']>;
  modTs?: Maybe<Scalars['DateTime']>;
  modBy?: Maybe<Scalars['String']>;
};

export type ExchangeLogInput = {
  exchangeRate?: Maybe<Scalars['Float']>;
  modTs?: Maybe<Scalars['DateTime']>;
  modBy?: Maybe<Scalars['String']>;
};

export type FieldError = {
  __typename?: 'FieldError';
  field: Scalars['String'];
  message: Scalars['String'];
};

export type FromBankAccountEntity = AuditEntity & {
  __typename?: 'FromBankAccountEntity';
  createdTs: Scalars['DateTime'];
  createdBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  modBy?: Maybe<Scalars['String']>;
  ID: Scalars['String'];
  accountID: Scalars['String'];
  name: Scalars['String'];
  accountHolder: Scalars['String'];
  accountNo: Scalars['String'];
  branch: Scalars['String'];
  address: Address;
  account: AccountEntity;
};

export type FromBankAccountInput = {
  accountHolder?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  branch?: Maybe<Scalars['String']>;
  ID?: Maybe<Scalars['String']>;
};

export type FromBankDetails = {
  __typename?: 'FromBankDetails';
  name?: Maybe<Scalars['String']>;
  acctHolder?: Maybe<Scalars['String']>;
  acctNo?: Maybe<Scalars['String']>;
  branch?: Maybe<Scalars['String']>;
};

export type FromBankDetailsInput = {
  name?: Maybe<Scalars['String']>;
  acctHolder?: Maybe<Scalars['String']>;
  acctNo?: Maybe<Scalars['String']>;
  branch?: Maybe<Scalars['String']>;
};

export type GlRevenueMapping = {
  __typename?: 'GLRevenueMapping';
  ExpenseDiv?: Maybe<Scalars['String']>;
  RevenueDiv?: Maybe<Scalars['String']>;
  ReverseDiv?: Maybe<Scalars['String']>;
  ExpenseDept?: Maybe<Scalars['String']>;
  RevenueDept?: Maybe<Scalars['String']>;
  ReverseDept?: Maybe<Scalars['String']>;
  ExpenseDebit?: Maybe<Scalars['String']>;
  RevenueDebit?: Maybe<Scalars['String']>;
  ReverseDebit?: Maybe<Scalars['String']>;
  ExpenseCredit?: Maybe<Scalars['String']>;
  RevenueCredit?: Maybe<Scalars['String']>;
  ReverseCredit?: Maybe<Scalars['String']>;
  modTs?: Maybe<Scalars['DateTime']>;
  modBy?: Maybe<Scalars['String']>;
};

export type GlRevenueMappingInput = {
  ExpenseDiv?: Maybe<Scalars['String']>;
  RevenueDiv?: Maybe<Scalars['String']>;
  ReverseDiv?: Maybe<Scalars['String']>;
  ExpenseDept?: Maybe<Scalars['String']>;
  RevenueDept?: Maybe<Scalars['String']>;
  ReverseDept?: Maybe<Scalars['String']>;
  ExpenseDebit?: Maybe<Scalars['String']>;
  RevenueDebit?: Maybe<Scalars['String']>;
  ReverseDebit?: Maybe<Scalars['String']>;
  ExpenseCredit?: Maybe<Scalars['String']>;
  RevenueCredit?: Maybe<Scalars['String']>;
  ReverseCredit?: Maybe<Scalars['String']>;
  modTs?: Maybe<Scalars['DateTime']>;
  modBy?: Maybe<Scalars['String']>;
};

export enum HrPackage {
  Platformadmin = 'PLATFORMADMIN',
  Systemadmin = 'SYSTEMADMIN',
  Payroll = 'PAYROLL',
  Personnel = 'PERSONNEL',
  Employeeengagement = 'EMPLOYEEENGAGEMENT',
  Businessinsight = 'BUSINESSINSIGHT',
  Leavemanagement = 'LEAVEMANAGEMENT',
  Claimmanagement = 'CLAIMMANAGEMENT',
  Requisitionmanagement = 'REQUISITIONMANAGEMENT',
  Timeattendance = 'TIMEATTENDANCE',
  Reporting = 'REPORTING',
  Staffappraisal = 'STAFFAPPRAISAL',
  Trainingdevelopment = 'TRAININGDEVELOPMENT',
  Timesheet = 'TIMESHEET',
  Projectexpensemanagement = 'PROJECTEXPENSEMANAGEMENT',
  Coolbinet = 'COOLBINET',
  Helpdesk = 'HELPDESK',
  Recruitment = 'RECRUITMENT',
  Einvoice = 'EINVOICE'
}

export enum HotelPackage {
  Platformadmin = 'PLATFORMADMIN',
  Pms = 'PMS',
  Cityledger = 'CITYLEDGER',
  Microsite = 'MICROSITE',
  Hotelplatform = 'HOTELPLATFORM',
  Guestapp = 'GUESTAPP',
  Travelagent = 'TRAVELAGENT',
  Corporategovernment = 'CORPORATEGOVERNMENT',
  Einvoice = 'EINVOICE'
}

export type HuaweiStorageOutput = {
  __typename?: 'HuaweiStorageOutput';
  BucketFileName: Scalars['String'];
  FileName: Scalars['String'];
  Url: Scalars['String'];
  MediaType: Scalars['String'];
  IsPrivate?: Maybe<Scalars['Boolean']>;
  PrivateUrl?: Maybe<Scalars['String']>;
};

export enum IfcaPackage {
  Marketing = 'MARKETING',
  Sales = 'SALES',
  Contract = 'CONTRACT',
  Issue = 'ISSUE'
}

export type InternalUserEntity = AuditEntity & {
  __typename?: 'InternalUserEntity';
  createdTs: Scalars['DateTime'];
  createdBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  modBy?: Maybe<Scalars['String']>;
  ID: Scalars['String'];
  userName?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  contactNo: Scalars['String'];
  is2FA?: Maybe<Scalars['Boolean']>;
  commonStatus: CommonStatus;
  confirmed: Scalars['Boolean'];
  avatar?: Maybe<Scalars['String']>;
  superUser: Scalars['Boolean'];
  accountID: Scalars['String'];
  softwareCode: Scalars['String'];
  loginAttempt: Scalars['Float'];
  blockDuration: Scalars['Float'];
  blockCount: Scalars['Float'];
  loginTs?: Maybe<Scalars['DateTime']>;
  deviceIP?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  address?: Maybe<Address>;
  department?: Maybe<Scalars['String']>;
  jobTitle?: Maybe<Scalars['String']>;
  lastestAccessedEntity?: Maybe<Scalars['String']>;
  roleID?: Maybe<Scalars['String']>;
};


export type LicenseEntity = AuditEntity & {
  __typename?: 'LicenseEntity';
  createdTs: Scalars['DateTime'];
  createdBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  modBy?: Maybe<Scalars['String']>;
  ID: Scalars['String'];
  accountID: Scalars['String'];
  subscriptionID: Scalars['String'];
  description: Scalars['String'];
  hardwareIDs: Scalars['String'];
  license: Scalars['String'];
  expiryDate: Scalars['DateTime'];
  notifyExpiryDate: Scalars['Float'];
  entityControl?: Maybe<LicenseEntityControl>;
  commonStatus: CommonStatus;
  voidReason?: Maybe<Scalars['String']>;
  /** CustomFieldResolver */
  daysToGo: Scalars['Float'];
};

/** JsonType */
export type LicenseEntityControl = {
  __typename?: 'LicenseEntityControl';
  noOfUser?: Maybe<Scalars['Float']>;
  noOfEntity?: Maybe<Scalars['Float']>;
  noofExtraEntity?: Maybe<Scalars['Float']>;
  modules: Scalars['String'];
};

export type LicenseEntityControlInput = {
  noOfUser?: Maybe<Scalars['Float']>;
  noOfEntity?: Maybe<Scalars['Float']>;
  noofExtraEntity?: Maybe<Scalars['Float']>;
  modules: Scalars['String'];
};

export type LicenseInput = {
  description: Scalars['String'];
  hardwareIDs: Scalars['String'];
  accountID: Scalars['String'];
  subscriptionID: Scalars['String'];
  NotifyExpiryDate: Scalars['Float'];
};

export type LocalBankDeleteInput = {
  ID: Scalars['String'];
};

export type LocalBankEntity = AuditEntity & {
  __typename?: 'LocalBankEntity';
  createdTs: Scalars['DateTime'];
  createdBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  modBy?: Maybe<Scalars['String']>;
  ID: Scalars['String'];
  countryID?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  code: Scalars['String'];
  address: Address;
  contactNo: Scalars['String'];
  faxNo?: Maybe<Scalars['String']>;
  website?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  commonStatus: CommonStatus;
};

export type LocalBankInput = {
  ID?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['String']>;
};

export type LoginResponse = {
  __typename?: 'LoginResponse';
  accessToken: Scalars['String'];
  user: UserResponse;
};

export enum MenuPackages {
  Outlet = 'OUTLET',
  Patron = 'PATRON',
  Kitchen = 'KITCHEN',
  Einvoice = 'EINVOICE'
}

export type ModuleDeleteInput = {
  ID: Scalars['String'];
};

export type ModuleEntity = AuditEntity & {
  __typename?: 'ModuleEntity';
  createdTs: Scalars['DateTime'];
  createdBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  modBy?: Maybe<Scalars['String']>;
  ID: Scalars['String'];
  productID: Scalars['String'];
  product: ProductEntity;
  name: Scalars['String'];
  code: Scalars['String'];
  sequence: Scalars['Float'];
  environmentUrl?: Maybe<Array<EnvironmentUrl>>;
  commonStatus: CommonStatus;
};

export type ModuleInput = {
  ID?: Maybe<Scalars['String']>;
  productID?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  code: Scalars['String'];
  sequence?: Maybe<Scalars['Float']>;
  commonStatus: CommonStatus;
};

export type Mutation = {
  __typename?: 'Mutation';
  UploadAttachmentProduct: AzureStorageOutput;
  uploadAttachments: Scalars['Boolean'];
  deleteAttachment: Scalars['Boolean'];
  createCurrency: CurrencyNoteEntity;
  updateCurrency: CurrencyNoteEntity;
  deleteCurrency: Scalars['Boolean'];
  patchLocalBankList: Scalars['JSON'];
  patchJohorDistrict: Scalars['JSON'];
  patchMissingCities: Scalars['JSON'];
  patchStateDistrict: Scalars['JSON'];
  createCountry: CountryEntity;
  updateCountry: CountryEntity;
  deleteCountry: Scalars['Boolean'];
  createState: StateEntity;
  updateState: StateEntity;
  deleteState: Scalars['Boolean'];
  createCity: CityEntity;
  updateCity: CityEntity;
  deleteCity: Scalars['Boolean'];
  createDistrict: DistrictEntity;
  updateDistrict: DistrictEntity;
  deleteDistrict: Scalars['Boolean'];
  createPostcode: PostcodeEntity;
  updatePostcode: PostcodeEntity;
  deletePostcode: Scalars['Boolean'];
  createLocalBank: LocalBankEntity;
  updateLocalBank: LocalBankEntity;
  deleteLocalBank: Scalars['Boolean'];
  deleteAccount: Scalars['Boolean'];
  createAccount: AccountEntity;
  updateAccount: AccountEntity;
  createAllowedOrigin: AllowedOriginEntity;
  updateAllowedOrigin: AllowedOriginEntity;
  deleteAllowedOrigin: Scalars['Boolean'];
  createFromBankAccount: FromBankAccountEntity;
  updateFromBankAccount: FromBankAccountEntity;
  deleteFromBankAccount: Scalars['Boolean'];
  createDownloadLog: Scalars['Boolean'];
  emailBlast: Scalars['Boolean'];
  generateLicense: Scalars['String'];
  deactivateLicense: Scalars['Boolean'];
  createModule: ModuleEntity;
  updateModule: ModuleEntity;
  deleteModule: Scalars['Boolean'];
  updatePackage: PackageEntity;
  deletePackage: Scalars['Boolean'];
  patchProduct: Scalars['JSON'];
  patchModule: Scalars['JSON'];
  createProduct: ProductEntity;
  updateProduct: ProductEntity;
  deleteProduct: Scalars['Boolean'];
  createReportLog: Scalars['Boolean'];
  createRole: RoleEntity;
  updateRole: RoleEntity;
  deleteRole: Scalars['Boolean'];
  assignRoleProduct: Scalars['Boolean'];
  unAssignRoleProduct: Scalars['Boolean'];
  assignRoleAccount: Scalars['Boolean'];
  unAssignRoleAccount: Scalars['Boolean'];
  updateSoftware: SoftwareEntity;
  deleteSoftware: Scalars['Boolean'];
  createSubscription: SubscriptionEntity;
  updateSubscription: Scalars['Boolean'];
  createTermsConditions: TermsConditionsEntity;
  updateTermsConditions: TermsConditionsEntity;
  createUser: InternalUserEntity;
  createPassword: Scalars['Boolean'];
  updateUser: InternalUserEntity;
  activateUser: Scalars['Boolean'];
  login: LoginResponse;
  changePassword: Scalars['Boolean'];
  logout: Scalars['Boolean'];
  changePwdUnblockUser: Scalars['Boolean'];
  forgotPassword: Scalars['Boolean'];
  resetPassword: Scalars['Boolean'];
  TwoFATotpSecretToggle: Scalars['Boolean'];
  totpValidate: Scalars['Boolean'];
  createUserActionLog: UserActionLogEntity;
  createOnlineUserLog: UserActionLogEntity;
  deleteOnlinUserLog: Scalars['Boolean'];
  logUserOnline: Scalars['Boolean'];
  logUserOffline: Scalars['Boolean'];
  logUserOfflineWithoutSocketId: Scalars['Boolean'];
  TestBlast: Scalars['Boolean'];
};


export type MutationUploadAttachmentProductArgs = {
  isPrivate?: Maybe<Scalars['Boolean']>;
  file: Scalars['Upload'];
};


export type MutationUploadAttachmentsArgs = {
  input: AttachmentInput;
};


export type MutationDeleteAttachmentArgs = {
  refID?: Maybe<Scalars['String']>;
  ID?: Maybe<Scalars['String']>;
};


export type MutationCreateCurrencyArgs = {
  input: CurrencyInput;
};


export type MutationUpdateCurrencyArgs = {
  input: CurrencyInput;
};


export type MutationDeleteCurrencyArgs = {
  input: CurrencyDeleteInput;
};


export type MutationPatchStateDistrictArgs = {
  state: Scalars['String'];
};


export type MutationCreateCountryArgs = {
  input: CountryInput;
};


export type MutationUpdateCountryArgs = {
  input: CountryInput;
};


export type MutationDeleteCountryArgs = {
  input: CountryInput;
};


export type MutationCreateStateArgs = {
  input: StateInput;
};


export type MutationUpdateStateArgs = {
  input: StateInput;
};


export type MutationDeleteStateArgs = {
  input: StateInput;
};


export type MutationCreateCityArgs = {
  input: CityInput;
};


export type MutationUpdateCityArgs = {
  input: CityInput;
};


export type MutationDeleteCityArgs = {
  input: CityInput;
};


export type MutationCreateDistrictArgs = {
  input: DistrictInput;
};


export type MutationUpdateDistrictArgs = {
  input: DistrictInput;
};


export type MutationDeleteDistrictArgs = {
  input: DistrictInput;
};


export type MutationCreatePostcodeArgs = {
  input: PostcodeInput;
};


export type MutationUpdatePostcodeArgs = {
  input: PostcodeInput;
};


export type MutationDeletePostcodeArgs = {
  input: PostcodeInput;
};


export type MutationCreateLocalBankArgs = {
  input: LocalBankInput;
};


export type MutationUpdateLocalBankArgs = {
  input: LocalBankInput;
};


export type MutationDeleteLocalBankArgs = {
  input: LocalBankDeleteInput;
};


export type MutationDeleteAccountArgs = {
  input: AccountDeleteInput;
};


export type MutationCreateAccountArgs = {
  input: AccountInput;
};


export type MutationUpdateAccountArgs = {
  input: AccountInput;
};


export type MutationCreateAllowedOriginArgs = {
  input: AllowedOriginInput;
};


export type MutationUpdateAllowedOriginArgs = {
  input: AllowedOriginInput;
};


export type MutationDeleteAllowedOriginArgs = {
  input: AllowedOriginDeleteInput;
};


export type MutationCreateFromBankAccountArgs = {
  input: FromBankAccountInput;
};


export type MutationUpdateFromBankAccountArgs = {
  input: FromBankAccountInput;
};


export type MutationDeleteFromBankAccountArgs = {
  input: FromBankAccountInput;
};


export type MutationCreateDownloadLogArgs = {
  input: DownloadLogInput;
};


export type MutationEmailBlastArgs = {
  userID: Scalars['String'];
  softwareCode: Scalars['String'];
  accountID: Scalars['String'];
  input: EmailBlastInput;
};


export type MutationGenerateLicenseArgs = {
  input: LicenseInput;
};


export type MutationDeactivateLicenseArgs = {
  reason: Scalars['String'];
  subscriptionID: Scalars['String'];
  ID: Scalars['String'];
};


export type MutationCreateModuleArgs = {
  input: ModuleInput;
};


export type MutationUpdateModuleArgs = {
  input: ModuleInput;
};


export type MutationDeleteModuleArgs = {
  input: ModuleDeleteInput;
};


export type MutationUpdatePackageArgs = {
  input: PackageInput;
};


export type MutationDeletePackageArgs = {
  input: PackageDeleteInput;
};


export type MutationCreateProductArgs = {
  input: ProductInput;
};


export type MutationUpdateProductArgs = {
  input: ProductInput;
};


export type MutationDeleteProductArgs = {
  input: ProductDeleteInput;
};


export type MutationCreateReportLogArgs = {
  input: ReportLogInput;
};


export type MutationCreateRoleArgs = {
  input: RoleInput;
};


export type MutationUpdateRoleArgs = {
  input: RoleInput;
};


export type MutationDeleteRoleArgs = {
  ID: Scalars['String'];
};


export type MutationAssignRoleProductArgs = {
  input: RoleProductAssignmentInput;
};


export type MutationUnAssignRoleProductArgs = {
  input: RoleProductAssignmentInput;
};


export type MutationAssignRoleAccountArgs = {
  input: RoleAccountAssignmentInput;
};


export type MutationUnAssignRoleAccountArgs = {
  input: RoleAccountAssignmentInput;
};


export type MutationUpdateSoftwareArgs = {
  input: SoftwareInput;
};


export type MutationDeleteSoftwareArgs = {
  input: SoftwareDelInput;
};


export type MutationCreateSubscriptionArgs = {
  input: SubscriptionInput;
};


export type MutationUpdateSubscriptionArgs = {
  input: SubscriptionUpdateInput;
};


export type MutationCreateTermsConditionsArgs = {
  input: TermsConditionsInput;
};


export type MutationUpdateTermsConditionsArgs = {
  input: TermsConditionsInput;
};


export type MutationCreateUserArgs = {
  input: UserInput;
};


export type MutationCreatePasswordArgs = {
  confirmPassword: Scalars['String'];
  password: Scalars['String'];
  accountID: Scalars['String'];
  userID: Scalars['String'];
};


export type MutationUpdateUserArgs = {
  input: UserInput;
};


export type MutationActivateUserArgs = {
  token: Scalars['String'];
};


export type MutationLoginArgs = {
  password: Scalars['String'];
  loginId: Scalars['String'];
};


export type MutationChangePasswordArgs = {
  newPassword: Scalars['String'];
  currentPassword: Scalars['String'];
};


export type MutationChangePwdUnblockUserArgs = {
  confirmPassword: Scalars['String'];
  password: Scalars['String'];
  ID: Scalars['String'];
};


export type MutationForgotPasswordArgs = {
  email: Scalars['String'];
};


export type MutationResetPasswordArgs = {
  accountID?: Maybe<Scalars['String']>;
  userID?: Maybe<Scalars['String']>;
  password: Scalars['String'];
  token: Scalars['String'];
};


export type MutationTwoFaTotpSecretToggleArgs = {
  is2FAEnable: Scalars['Boolean'];
};


export type MutationTotpValidateArgs = {
  token: Scalars['String'];
};


export type MutationCreateUserActionLogArgs = {
  input: UserActionLogInput;
};


export type MutationCreateOnlineUserLogArgs = {
  input: OnlineUserInput;
};


export type MutationDeleteOnlinUserLogArgs = {
  accountID: Scalars['String'];
  userID: Scalars['String'];
};


export type MutationLogUserOnlineArgs = {
  ipAddress?: Maybe<Scalars['String']>;
  packageName?: Maybe<Scalars['String']>;
  entityID?: Maybe<Scalars['String']>;
  socketID: Scalars['String'];
  accountID: Scalars['String'];
  softwareName: Scalars['String'];
  userID: Scalars['String'];
};


export type MutationLogUserOfflineArgs = {
  packageName?: Maybe<Scalars['String']>;
  entityID?: Maybe<Scalars['String']>;
  socketID: Scalars['String'];
  accountID: Scalars['String'];
  softwareName: Scalars['String'];
  userID: Scalars['String'];
};


export type MutationLogUserOfflineWithoutSocketIdArgs = {
  packageName?: Maybe<Scalars['String']>;
  entityID?: Maybe<Scalars['String']>;
  accountID: Scalars['String'];
  softwareName: Scalars['String'];
  userID: Scalars['String'];
};


export type MutationTestBlastArgs = {
  accountID: Scalars['String'];
  userID: Scalars['String'];
};

export enum NumericFormatter {
  Lumpsum = 'LUMPSUM',
  Thousands = 'THOUSANDS',
  Millions = 'MILLIONS',
  Billions = 'BILLIONS'
}

export type OnlineUserEntity = AuditEntity & {
  __typename?: 'OnlineUserEntity';
  createdTs: Scalars['DateTime'];
  createdBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  modBy?: Maybe<Scalars['String']>;
  ID: Scalars['String'];
  softwareID?: Maybe<Scalars['String']>;
  softwareName?: Maybe<Scalars['String']>;
  packageName?: Maybe<Scalars['String']>;
  entityName?: Maybe<Scalars['String']>;
  userID: Scalars['String'];
  userName?: Maybe<Scalars['String']>;
  accountID?: Maybe<Scalars['String']>;
  entityID?: Maybe<Scalars['String']>;
  ipAddress?: Maybe<Scalars['String']>;
  loginDateTime?: Maybe<Scalars['DateTime']>;
  commonStatus: Scalars['String'];
  lastLogin: Scalars['DateTime'];
  lastLogout?: Maybe<Scalars['DateTime']>;
  socketID?: Maybe<Scalars['String']>;
};

export type OnlineUserInput = {
  softwareID?: Maybe<Scalars['String']>;
  softwareName?: Maybe<Scalars['String']>;
  packageName?: Maybe<Scalars['String']>;
  entityName?: Maybe<Scalars['String']>;
  userID: Scalars['String'];
  userName?: Maybe<Scalars['String']>;
  accountID: Scalars['String'];
  ipAddress: Scalars['String'];
};

export type PackageDeleteInput = {
  ID: Scalars['String'];
};

export type PackageEntity = AuditEntity & {
  __typename?: 'PackageEntity';
  createdTs: Scalars['DateTime'];
  createdBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  modBy?: Maybe<Scalars['String']>;
  ID: Scalars['String'];
  name: Scalars['String'];
  softwareID: Scalars['String'];
  software: SoftwareEntity;
};

export type PackageInput = {
  ID?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  softwareID?: Maybe<Scalars['String']>;
};

export type PostcodeEntity = AuditEntity & {
  __typename?: 'PostcodeEntity';
  createdTs: Scalars['DateTime'];
  createdBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  modBy?: Maybe<Scalars['String']>;
  ID: Scalars['String'];
  name?: Maybe<Scalars['String']>;
  postcode: Scalars['String'];
  cityID: Scalars['String'];
  city: CityEntity;
  commonStatus: CommonStatus;
};

export type PostcodeInput = {
  postcode?: Maybe<Scalars['String']>;
  cityID?: Maybe<Scalars['String']>;
  ID?: Maybe<Scalars['String']>;
};

export type ProductDeleteInput = {
  ID: Scalars['String'];
};

export type ProductEntity = AuditEntity & {
  __typename?: 'ProductEntity';
  createdTs: Scalars['DateTime'];
  createdBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  modBy?: Maybe<Scalars['String']>;
  ID: Scalars['String'];
  name: Scalars['String'];
  code: Scalars['String'];
  description: Scalars['String'];
  accessTokenSecret: Scalars['String'];
  refreshTokenSecret: Scalars['String'];
  environmentUrl?: Maybe<Array<EnvironmentUrl>>;
  commonStatus: CommonStatus;
  module: Array<ModuleEntity>;
};

export type ProductInput = {
  ID?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  description: Scalars['String'];
  code: Scalars['String'];
};

export enum PropertyPackages {
  AgencyPlatform = 'AGENCY_PLATFORM',
  LoanPlatform = 'LOAN_PLATFORM',
  SalesPlatform = 'SALES_PLATFORM',
  SolicitorPlatform = 'SOLICITOR_PLATFORM',
  PurchaserApp = 'PURCHASER_APP',
  ELaunch = 'E_LAUNCH',
  SalesAdmin = 'SALES_ADMIN',
  ReportDesigner = 'REPORT_DESIGNER',
  Einvoice = 'EINVOICE'
}

export type Query = {
  __typename?: 'Query';
  DeleteAttachmentProduct: Scalars['Boolean'];
  DeleteAttachmentProducts: Scalars['Boolean'];
  AttachmentListing?: Maybe<Array<AttachmentEntity>>;
  getCurrency: Array<CurrencyNoteEntity>;
  getCountry: Array<CountryEntity>;
  getState: Array<StateEntity>;
  getStatebyCountry: Array<StateEntity>;
  getCitybyState: Array<CityEntity>;
  getDistrictbyCity: Array<DistrictEntity>;
  getPostcodebyCity: Array<PostcodeEntity>;
  getLocalBank: Array<LocalBankEntity>;
  getAccount: Array<AccountEntity>;
  accountConfig: AccountConfigEntity;
  getAccountDetail?: Maybe<AccountEntity>;
  getAccountsBySoftwareCode: Array<AccountEntity>;
  getAccountsBySoftwareCodeForUser: Array<AccountEntity>;
  getAllowedOrigin: Array<AllowedOriginEntity>;
  getAllowedOriginByProduct: Array<AllowedOriginEntity>;
  getFromBankAccount: Array<FromBankAccountEntity>;
  getLicense?: Maybe<Array<LicenseEntity>>;
  getModule: Array<ModuleEntity>;
  getModuleByProduct: Array<ModuleEntity>;
  getPackageByAccount: Array<Scalars['String']>;
  getPackageSoftwareCode: Array<Scalars['String']>;
  getProduct: Array<ProductEntity>;
  getIfcaProduct: Array<ProductEntity>;
  getProductForUser: Array<ProductEntity>;
  getRole: Array<RoleEntity>;
  getRoleProduct: Array<RoleProductEntity>;
  getRoleAccount: Array<RoleAccountEntity>;
  declareSoftwareCodeEnum: Scalars['String'];
  declareSoftwarePackagesEnum: Scalars['JSON'];
  getSubscription: Array<SubscriptionEntity>;
  testPath: Scalars['JSON'];
  subscribedUserAndEntityCount: SubscriptionEntity;
  getRemainingSubscriptionDays: Scalars['Float'];
  getTermsConditions: Array<TermsConditionsEntity>;
  loggedInUserProfile: InternalUserEntity;
  activeUser: Scalars['Float'];
  getUsersByAccount: Array<InternalUserEntity>;
  getUser: InternalUserEntity;
  getUsersbyIds: Array<InternalUserEntity>;
  unLockUser: Scalars['Boolean'];
  isLoginPermitted: InternalUserEntity;
  isUserValid: Scalars['Boolean'];
  getUsersBySoftware: Array<InternalUserEntity>;
  getSuperUsers: Array<InternalUserEntity>;
  TwoFATotpDetails: TotpSecretTyes;
};


export type QueryDeleteAttachmentProductArgs = {
  isPrivate?: Maybe<Scalars['Boolean']>;
  filename: Scalars['String'];
};


export type QueryDeleteAttachmentProductsArgs = {
  isPrivate?: Maybe<Scalars['Boolean']>;
  filenames: Array<Scalars['String']>;
};


export type QueryAttachmentListingArgs = {
  refTable?: Maybe<Scalars['String']>;
  refID?: Maybe<Scalars['String']>;
  ID?: Maybe<Scalars['String']>;
};


export type QueryGetCurrencyArgs = {
  orderByDesc?: Maybe<Scalars['String']>;
  orderByAsc?: Maybe<Scalars['String']>;
  skip?: Maybe<Scalars['Float']>;
  take?: Maybe<Scalars['Float']>;
  ID?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['String']>;
  symbol?: Maybe<Scalars['String']>;
};


export type QueryGetCountryArgs = {
  orderByDesc?: Maybe<Scalars['String']>;
  orderByAsc?: Maybe<Scalars['String']>;
  skip?: Maybe<Scalars['Float']>;
  take?: Maybe<Scalars['Float']>;
  ID?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['String']>;
};


export type QueryGetStateArgs = {
  ID?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['String']>;
  orderByDesc?: Maybe<Scalars['String']>;
  orderByAsc?: Maybe<Scalars['String']>;
  skip?: Maybe<Scalars['Float']>;
  take?: Maybe<Scalars['Float']>;
  countryID?: Maybe<Scalars['String']>;
};


export type QueryGetStatebyCountryArgs = {
  countryID: Scalars['String'];
};


export type QueryGetCitybyStateArgs = {
  stateID: Scalars['String'];
};


export type QueryGetDistrictbyCityArgs = {
  cityID: Scalars['String'];
};


export type QueryGetPostcodebyCityArgs = {
  cityID: Scalars['String'];
};


export type QueryGetLocalBankArgs = {
  orderByDesc?: Maybe<Scalars['String']>;
  orderByAsc?: Maybe<Scalars['String']>;
  skip?: Maybe<Scalars['Float']>;
  take?: Maybe<Scalars['Float']>;
  ID?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['String']>;
};


export type QueryGetAccountArgs = {
  isInternal?: Maybe<Scalars['Boolean']>;
  commonStatus?: Maybe<CommonStatus>;
  ID?: Maybe<Scalars['String']>;
};


export type QueryAccountConfigArgs = {
  accountID: Scalars['String'];
};


export type QueryGetAccountDetailArgs = {
  accountID: Scalars['String'];
};


export type QueryGetAccountsBySoftwareCodeArgs = {
  softwareCode: Scalars['String'];
};


export type QueryGetAccountsBySoftwareCodeForUserArgs = {
  softwareCode: Scalars['String'];
};


export type QueryGetAllowedOriginArgs = {
  orderByDesc?: Maybe<Scalars['String']>;
  orderByAsc?: Maybe<Scalars['String']>;
  origin?: Maybe<Scalars['String']>;
  productID?: Maybe<Scalars['String']>;
  ID?: Maybe<Scalars['String']>;
};


export type QueryGetAllowedOriginByProductArgs = {
  productID: Scalars['String'];
};


export type QueryGetFromBankAccountArgs = {
  orderByDesc?: Maybe<Scalars['String']>;
  orderByAsc?: Maybe<Scalars['String']>;
  skip?: Maybe<Scalars['Float']>;
  take?: Maybe<Scalars['Float']>;
  ID?: Maybe<Scalars['String']>;
};


export type QueryGetLicenseArgs = {
  subscriptionID: Scalars['String'];
  accountID: Scalars['String'];
};


export type QueryGetModuleArgs = {
  orderByDesc?: Maybe<Scalars['String']>;
  orderByAsc?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  productID?: Maybe<Scalars['String']>;
  ID?: Maybe<Scalars['String']>;
};


export type QueryGetModuleByProductArgs = {
  productID: Scalars['String'];
};


export type QueryGetPackageByAccountArgs = {
  softwareCode: Scalars['String'];
  accountID: Scalars['String'];
};


export type QueryGetPackageSoftwareCodeArgs = {
  softwareCode: Scalars['String'];
};


export type QueryGetProductArgs = {
  orderByDesc?: Maybe<Scalars['String']>;
  orderByAsc?: Maybe<Scalars['String']>;
  skip?: Maybe<Scalars['Float']>;
  take?: Maybe<Scalars['Float']>;
  ID?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};


export type QueryGetIfcaProductArgs = {
  orderByDesc?: Maybe<Scalars['String']>;
  orderByAsc?: Maybe<Scalars['String']>;
  commonStatuss?: Maybe<CommonStatus>;
  code?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  ID?: Maybe<Scalars['String']>;
};


export type QueryGetRoleArgs = {
  orderByDesc?: Maybe<Scalars['String']>;
  orderByAsc?: Maybe<Scalars['String']>;
  skip?: Maybe<Scalars['Float']>;
  take?: Maybe<Scalars['Float']>;
  ID?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};


export type QueryGetRoleProductArgs = {
  orderByDesc?: Maybe<Scalars['String']>;
  orderByAsc?: Maybe<Scalars['String']>;
  skip?: Maybe<Scalars['Float']>;
  take?: Maybe<Scalars['Float']>;
  roleID: Scalars['String'];
};


export type QueryGetRoleAccountArgs = {
  orderByDesc?: Maybe<Scalars['String']>;
  orderByAsc?: Maybe<Scalars['String']>;
  skip?: Maybe<Scalars['Float']>;
  take?: Maybe<Scalars['Float']>;
  roleID: Scalars['String'];
};


export type QueryDeclareSoftwareCodeEnumArgs = {
  SoftwareCode: SoftwareCode;
};


export type QueryDeclareSoftwarePackagesEnumArgs = {
  EinvoicePackages?: Maybe<EinvoicePackages>;
  AccountPackage?: Maybe<AccountPackage>;
  ReportDesignerPackage?: Maybe<ReportDesignerPackage>;
  PropertyPackages?: Maybe<PropertyPackages>;
  MenuPackages?: Maybe<MenuPackages>;
  IfcaPackage?: Maybe<IfcaPackage>;
  HRPackage?: Maybe<HrPackage>;
  EventPackage?: Maybe<EventPackage>;
  HotelPackage?: Maybe<HotelPackage>;
  ContractPackage?: Maybe<ContractPackage>;
};


export type QueryGetSubscriptionArgs = {
  orderByDesc?: Maybe<Scalars['String']>;
  orderByAsc?: Maybe<Scalars['String']>;
  skip?: Maybe<Scalars['Float']>;
  take?: Maybe<Scalars['Float']>;
  ID?: Maybe<Scalars['String']>;
  accountID?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};


export type QuerySubscribedUserAndEntityCountArgs = {
  softwareCode?: Maybe<SoftwareCode>;
  accountID: Scalars['String'];
};


export type QueryGetRemainingSubscriptionDaysArgs = {
  softwareCode?: Maybe<SoftwareCode>;
  accountID: Scalars['String'];
};


export type QueryGetTermsConditionsArgs = {
  orderByDesc?: Maybe<Scalars['String']>;
  orderByAsc?: Maybe<Scalars['String']>;
  skip?: Maybe<Scalars['Float']>;
  take?: Maybe<Scalars['Float']>;
  ID?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};


export type QueryGetUsersByAccountArgs = {
  status?: Maybe<CommonStatus>;
  superUser?: Maybe<Scalars['Boolean']>;
  LatetestUser?: Maybe<Scalars['Boolean']>;
  accountID: Scalars['String'];
};


export type QueryGetUserArgs = {
  ID: Scalars['String'];
};


export type QueryGetUsersbyIdsArgs = {
  userIDs: Array<Scalars['String']>;
};


export type QueryUnLockUserArgs = {
  password: Scalars['String'];
  accountID: Scalars['String'];
  userIDs: Scalars['String'];
};


export type QueryIsLoginPermittedArgs = {
  deviceIP: Scalars['String'];
};


export type QueryIsUserValidArgs = {
  userID: Scalars['String'];
};

export type Recipient = {
  __typename?: 'Recipient';
  name?: Maybe<Scalars['String']>;
  email: Scalars['String'];
};

export enum ReportDesignerPackage {
  Contract = 'CONTRACT',
  Hr = 'HR',
  Property = 'PROPERTY',
  Hotel = 'HOTEL',
  Menu = 'MENU',
  Account = 'ACCOUNT',
  Ifca = 'IFCA',
  Subscription = 'SUBSCRIPTION'
}

export type ReportLogEntity = {
  __typename?: 'ReportLogEntity';
  ID: Scalars['String'];
  accountID?: Maybe<Scalars['String']>;
  accountName?: Maybe<Scalars['String']>;
  softwareID?: Maybe<Scalars['String']>;
  softwareName?: Maybe<Scalars['String']>;
  userID?: Maybe<Scalars['String']>;
  userName?: Maybe<Scalars['String']>;
  reportName?: Maybe<Scalars['String']>;
  path?: Maybe<Scalars['String']>;
  requestDate?: Maybe<Scalars['DateTime']>;
};

export type ReportLogInput = {
  accountID?: Maybe<Scalars['String']>;
  accountName?: Maybe<Scalars['String']>;
  softwareID?: Maybe<Scalars['String']>;
  softwareName?: Maybe<Scalars['String']>;
  userID?: Maybe<Scalars['String']>;
  userName?: Maybe<Scalars['String']>;
  reportName?: Maybe<Scalars['String']>;
  path?: Maybe<Scalars['String']>;
};

export type RoleAccountAssignmentInput = {
  roleID: Scalars['String'];
  accountIDs: Array<Scalars['String']>;
};

export type RoleAccountEntity = AuditEntity & {
  __typename?: 'RoleAccountEntity';
  createdTs: Scalars['DateTime'];
  createdBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  modBy?: Maybe<Scalars['String']>;
  ID: Scalars['String'];
  roleID: Scalars['String'];
  accountID: Scalars['String'];
  role?: Maybe<RoleEntity>;
  account?: Maybe<AccountEntity>;
};

export type RoleDeleteInput = {
  ID: Scalars['String'];
};

export type RoleEntity = AuditEntity & {
  __typename?: 'RoleEntity';
  createdTs: Scalars['DateTime'];
  createdBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  modBy?: Maybe<Scalars['String']>;
  ID: Scalars['String'];
  name: Scalars['String'];
  commonStatus: CommonStatus;
  roleProduct?: Maybe<Array<RoleProductEntity>>;
  roleAccount?: Maybe<Array<RoleAccountEntity>>;
};

export type RoleInput = {
  ID?: Maybe<Scalars['String']>;
  name: Scalars['String'];
};

export type RoleProductAssignmentInput = {
  roleID: Scalars['String'];
  products: Array<Scalars['String']>;
};

export type RoleProductEntity = AuditEntity & {
  __typename?: 'RoleProductEntity';
  createdTs: Scalars['DateTime'];
  createdBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  modBy?: Maybe<Scalars['String']>;
  ID: Scalars['String'];
  roleID: Scalars['String'];
  productID: Scalars['String'];
  productCode?: Maybe<Scalars['String']>;
  role?: Maybe<RoleEntity>;
};

export enum SoftwareCode {
  Contract = 'CONTRACT',
  Site = 'SITE',
  Client = 'CLIENT',
  Subcontractor = 'SUBCONTRACTOR',
  Supplier = 'SUPPLIER',
  Hr = 'HR',
  Property = 'PROPERTY',
  Rent = 'RENT',
  Hotel = 'HOTEL',
  Account = 'ACCOUNT',
  Ifca = 'IFCA',
  Subscription = 'SUBSCRIPTION',
  User = 'USER',
  Tenant = 'TENANT',
  LeaseTodo = 'LEASE_TODO',
  LeaseOperation = 'LEASE_OPERATION',
  LeaseSales = 'LEASE_SALES',
  Menu = 'MENU',
  Event = 'EVENT',
  PosCustomer = 'POS_CUSTOMER',
  Probation = 'PROBATION',
  ReportDesigner = 'REPORT_DESIGNER',
  Project = 'PROJECT'
}

export type SoftwareDelInput = {
  ID: Scalars['String'];
};

export type SoftwareEntity = AuditEntity & {
  __typename?: 'SoftwareEntity';
  createdTs: Scalars['DateTime'];
  createdBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  modBy?: Maybe<Scalars['String']>;
  ID: Scalars['String'];
  name: Scalars['String'];
  code: Scalars['String'];
  subscriptionID: Scalars['String'];
  commonStatus: CommonStatus;
  subscription: SubscriptionEntity;
  package: Array<PackageEntity>;
};

export type SoftwareInput = {
  name?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['String']>;
};

export type SoftwareUpdateInput = {
  name?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['String']>;
};

export type StandardAuditEntity = {
  createdTs: Scalars['DateTime'];
  createdBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  modBy?: Maybe<Scalars['String']>;
};

export type StandardCoreBaseEntity = AuditEntity & {
  __typename?: 'StandardCoreBaseEntity';
  createdTs: Scalars['DateTime'];
  createdBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  modBy?: Maybe<Scalars['String']>;
  ID: Scalars['String'];
};

export type StateEntity = AuditEntity & {
  __typename?: 'StateEntity';
  createdTs: Scalars['DateTime'];
  createdBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  modBy?: Maybe<Scalars['String']>;
  ID: Scalars['String'];
  name: Scalars['String'];
  countryID: Scalars['String'];
  country: CountryEntity;
  eInvCode: Scalars['String'];
  commonStatus: CommonStatus;
  city: Array<CityEntity>;
};

export type StateInput = {
  name?: Maybe<Scalars['String']>;
  countryID?: Maybe<Scalars['String']>;
  ID?: Maybe<Scalars['String']>;
};

export type SubscriptionEntity = AuditEntity & {
  __typename?: 'SubscriptionEntity';
  createdTs: Scalars['DateTime'];
  createdBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  modBy?: Maybe<Scalars['String']>;
  ID: Scalars['String'];
  accountID: Scalars['String'];
  subscriptionAmt: Scalars['Float'];
  salesOrderNo: Scalars['String'];
  remark: Scalars['String'];
  terminationReason?: Maybe<Scalars['String']>;
  isTerminated: Scalars['Boolean'];
  saleOrderDate: Scalars['DateTime'];
  startDate: Scalars['DateTime'];
  endDate: Scalars['DateTime'];
  implementationDate?: Maybe<Scalars['DateTime']>;
  noOfUser: Scalars['Float'];
  is2FA: Scalars['Boolean'];
  entityControl?: Maybe<EntityControl>;
  commonStatus: CommonStatus;
  /** CustomFieldResolver */
  daysToGo: Scalars['Float'];
  account: AccountEntity;
  software: Array<SoftwareEntity>;
};

export type SubscriptionInput = {
  accountID: Scalars['String'];
  softwareCode: Scalars['String'];
  softwareName: Scalars['String'];
  subscriptionAmt?: Maybe<Scalars['Float']>;
  startDate: Scalars['DateTime'];
  endDate: Scalars['DateTime'];
  implementationDate: Scalars['DateTime'];
  noOfUser: Scalars['Float'];
  saleOrderDate?: Maybe<Scalars['DateTime']>;
  salesOrderNo?: Maybe<Scalars['String']>;
  remark: Scalars['String'];
  entityControl: EntityControlInput;
  packages: Array<Scalars['String']>;
  is2FA?: Maybe<Scalars['Boolean']>;
  file?: Maybe<Array<Scalars['Upload']>>;
};

export type SubscriptionUpdateInput = {
  ID?: Maybe<Scalars['String']>;
  accountID?: Maybe<Scalars['String']>;
  softwareCode?: Maybe<Scalars['String']>;
  softwareName?: Maybe<Scalars['String']>;
  subscriptionAmt?: Maybe<Scalars['Float']>;
  startDate?: Maybe<Scalars['DateTime']>;
  endDate?: Maybe<Scalars['DateTime']>;
  implementationDate: Scalars['DateTime'];
  noOfUser?: Maybe<Scalars['Float']>;
  saleOrderDate?: Maybe<Scalars['DateTime']>;
  salesOrderNo?: Maybe<Scalars['String']>;
  remark?: Maybe<Scalars['String']>;
  entityControl?: Maybe<EntityControlInput>;
  packages: Array<Scalars['String']>;
  terminationReason?: Maybe<Scalars['String']>;
  isTerminated?: Maybe<Scalars['Boolean']>;
  commonStatus?: Maybe<CommonStatus>;
  is2FA?: Maybe<Scalars['Boolean']>;
  file?: Maybe<Array<Scalars['Upload']>>;
};

export type TermsConditionsEntity = AuditEntity & {
  __typename?: 'TermsConditionsEntity';
  createdTs: Scalars['DateTime'];
  createdBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  modBy?: Maybe<Scalars['String']>;
  ID: Scalars['String'];
  name: Scalars['String'];
  softwareID: Scalars['String'];
  accountID?: Maybe<Scalars['String']>;
  description: Scalars['String'];
  account: AccountEntity;
};

export type TermsConditionsInput = {
  name: Scalars['String'];
  softwareID: Scalars['String'];
  accountID?: Maybe<Scalars['String']>;
  description: Scalars['String'];
};

export type TotpSecretTyes = {
  __typename?: 'TotpSecretTyes';
  is2FA?: Maybe<Scalars['Boolean']>;
  totpSecret?: Maybe<Scalars['String']>;
  dataURL?: Maybe<Scalars['String']>;
  otpURL?: Maybe<Scalars['String']>;
};

export type UpdateAuditInput = {
  modBy?: Maybe<Scalars['String']>;
};


export type UserActionLogEntity = {
  __typename?: 'UserActionLogEntity';
  ID: Scalars['String'];
  softwareID?: Maybe<Scalars['String']>;
  softwareName?: Maybe<Scalars['String']>;
  packageName?: Maybe<Scalars['String']>;
  entityName?: Maybe<Scalars['String']>;
  userID?: Maybe<Scalars['String']>;
  userName?: Maybe<Scalars['String']>;
  accountID?: Maybe<Scalars['String']>;
  accountName?: Maybe<Scalars['String']>;
  actionID?: Maybe<Scalars['String']>;
  actionName?: Maybe<Scalars['String']>;
  ipAddress?: Maybe<Scalars['String']>;
  loginDateTime?: Maybe<Scalars['DateTime']>;
};

export type UserActionLogInput = {
  softwareID?: Maybe<Scalars['String']>;
  softwareName?: Maybe<Scalars['String']>;
  packageName?: Maybe<Scalars['String']>;
  entityName?: Maybe<Scalars['String']>;
  userID?: Maybe<Scalars['String']>;
  userName?: Maybe<Scalars['String']>;
  accountID?: Maybe<Scalars['String']>;
  accountName?: Maybe<Scalars['String']>;
  actionID?: Maybe<Scalars['String']>;
  actionName?: Maybe<Scalars['String']>;
  ipAddress?: Maybe<Scalars['String']>;
};

export type UserEntity = AuditEntity & {
  __typename?: 'UserEntity';
  createdTs: Scalars['DateTime'];
  createdBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  modBy?: Maybe<Scalars['String']>;
  ID: Scalars['String'];
  userName?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  contactNo: Scalars['String'];
  is2FA?: Maybe<Scalars['Boolean']>;
  commonStatus: CommonStatus;
  confirmed: Scalars['Boolean'];
  avatar?: Maybe<Scalars['String']>;
  superUser: Scalars['Boolean'];
  accountID: Scalars['String'];
  softwareCode: Scalars['String'];
  loginAttempt: Scalars['Float'];
  blockDuration: Scalars['Float'];
  blockCount: Scalars['Float'];
  loginTs?: Maybe<Scalars['DateTime']>;
  deviceIP?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  address?: Maybe<Address>;
  department?: Maybe<Scalars['String']>;
  jobTitle?: Maybe<Scalars['String']>;
  lastestAccessedEntity?: Maybe<Scalars['String']>;
};

export type UserInput = {
  ID?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  contactNo: Scalars['String'];
  email: Scalars['String'];
  hashed?: Maybe<Scalars['String']>;
  password?: Maybe<Scalars['String']>;
  avatar?: Maybe<Scalars['String']>;
  userName?: Maybe<Scalars['String']>;
  jobTitle?: Maybe<Scalars['String']>;
  roleID?: Maybe<Scalars['String']>;
  superUser?: Maybe<Scalars['Boolean']>;
  department?: Maybe<Scalars['String']>;
  address?: Maybe<AddressInput>;
  commonStatus?: Maybe<CommonStatus>;
};

export type UserResponse = AuditEntity & {
  __typename?: 'UserResponse';
  createdTs: Scalars['DateTime'];
  createdBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  modBy?: Maybe<Scalars['String']>;
  ID: Scalars['String'];
  name: Scalars['String'];
  userName: Scalars['String'];
  email: Scalars['String'];
  contactNo: Scalars['String'];
  confirmed: Scalars['Boolean'];
  superUser: Scalars['Boolean'];
  accountID: Scalars['String'];
  commonStatus: CommonStatus;
  password?: Maybe<Scalars['String']>;
  department?: Maybe<Scalars['String']>;
  jobTitle?: Maybe<Scalars['String']>;
  avatar?: Maybe<Scalars['String']>;
  lastestAccessedEntity?: Maybe<Scalars['String']>;
  deviceIP?: Maybe<Scalars['String']>;
  loginTs?: Maybe<Scalars['DateTime']>;
  blockDuration?: Maybe<Scalars['Float']>;
  blockCount?: Maybe<Scalars['Float']>;
  loginAttempt?: Maybe<Scalars['Float']>;
  is2FA?: Maybe<Scalars['Boolean']>;
  address?: Maybe<Address>;
  errors?: Maybe<Array<FieldError>>;
};

export type EInvoiceClassificationEntity = {
  __typename?: 'eInvoiceClassificationEntity';
  id: Scalars['String'];
  classificationCode?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
};

export type EInvoiceGeneralTinEntity = {
  __typename?: 'eInvoiceGeneralTinEntity';
  id: Scalars['String'];
  tinParty?: Maybe<Scalars['String']>;
  tin?: Maybe<Scalars['String']>;
  displaySeq?: Maybe<Scalars['Float']>;
};

export type EInvoiceMsicEntity = {
  __typename?: 'eInvoiceMsicEntity';
  id: Scalars['String'];
  msicCode?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  categoryReference?: Maybe<Scalars['String']>;
  companyMsicAssignment: Array<CompanyMsicAssignmentEntity>;
};

export type EInvoiceUomEntity = {
  __typename?: 'eInvoiceUomEntity';
  id: Scalars['String'];
  code?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type LhdnEinvoiceSettingsEntity = {
  __typename?: 'lhdnEinvoiceSettingsEntity';
  eInvClientId: Scalars['String'];
  eInvClientSecret?: Maybe<Scalars['String']>;
  eInvClientSecret2?: Maybe<Scalars['String']>;
  eInvAccessToken?: Maybe<Scalars['String']>;
  eInvApiUrl?: Maybe<Scalars['String']>;
};

export type TaxDetailEntity = {
  __typename?: 'taxDetailEntity';
  id: Scalars['String'];
  accountId: Scalars['String'];
  taxId: Scalars['String'];
  tax: TaxEntity;
  effectiveDate: Scalars['DateTime'];
  rate: Scalars['Float'];
  commonStatus: Scalars['String'];
};

export type TaxEntity = {
  __typename?: 'taxEntity';
  id: Scalars['String'];
  accountId: Scalars['String'];
  schemeTypeId: Scalars['String'];
  schemeType: TaxSchemeTypeEntity;
  code: Scalars['String'];
  description: Scalars['String'];
  classType: Scalars['String'];
  isClaimable: Scalars['Boolean'];
  commonStatus: Scalars['String'];
  taxDetail: Array<TaxDetailEntity>;
  taxSchemeDetailItem: Array<TaxSchemeDetailItemEntity>;
};

export type TaxOnSeqInput = {
  taxSchemeDetailItemId: Scalars['String'];
  seqNo: Scalars['Float'];
};

/** JsonType */
export type TaxOnSeqObjects = {
  __typename?: 'taxOnSeqObjects';
  taxSchemeDetailItemId: Scalars['String'];
  seqNo: Scalars['Float'];
};

export type TaxSchemeDetailEntity = {
  __typename?: 'taxSchemeDetailEntity';
  id: Scalars['String'];
  accountId: Scalars['String'];
  taxSchemeId: Scalars['String'];
  taxScheme: TaxSchemeEntity;
  effectiveDate: Scalars['DateTime'];
  commonStatus: Scalars['String'];
  taxSchemeDetailItems?: Maybe<Array<TaxSchemeDetailItemEntity>>;
};

export type TaxSchemeDetailItemEntity = {
  __typename?: 'taxSchemeDetailItemEntity';
  id: Scalars['String'];
  accountId: Scalars['String'];
  taxSchemeDetailId: Scalars['String'];
  taxSchemeDetail: TaxSchemeDetailEntity;
  taxId: Scalars['String'];
  tax: TaxEntity;
  computeMethod: Scalars['String'];
  seqNo?: Maybe<Scalars['Float']>;
  taxOnSeq?: Maybe<Array<TaxOnSeqObjects>>;
  commonStatus: Scalars['String'];
};

export type TaxSchemeEntity = {
  __typename?: 'taxSchemeEntity';
  id: Scalars['String'];
  accountId: Scalars['String'];
  name: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  isExclusive?: Maybe<Scalars['Boolean']>;
  commonStatus: Scalars['String'];
  taxSchemeDetails?: Maybe<Array<TaxSchemeDetailEntity>>;
};

export type TaxSchemeTypeEntity = {
  __typename?: 'taxSchemeTypeEntity';
  id: Scalars['String'];
  code: Scalars['String'];
  name: Scalars['String'];
  softwareCode: Scalars['String'];
  commonStatus: Scalars['String'];
  tax?: Maybe<Array<TaxEntity>>;
};

export type GetAccountQueryVariables = Exact<{
  ID?: Maybe<Scalars['String']>;
}>;


export type GetAccountQuery = (
  { __typename?: 'Query' }
  & { getAccount: Array<(
    { __typename?: 'AccountEntity' }
    & Pick<AccountEntity, 'ID' | 'name' | 'code' | 'contactNo' | 'email' | 'currencyID' | 'commonStatus' | 'regNo' | 'modTs' | 'isInternal' | 'image' | 'imageUrl'>
    & { currency?: Maybe<(
      { __typename?: 'CurrencyNoteEntity' }
      & Pick<CurrencyNoteEntity, 'ID' | 'name' | 'code'>
    )>, address?: Maybe<(
      { __typename?: 'Address' }
      & Pick<Address, 'address' | 'city' | 'state' | 'country' | 'postCode'>
    )>, contactPerson?: Maybe<Array<(
      { __typename?: 'ContactPerson' }
      & Pick<ContactPerson, 'name' | 'designation' | 'contactNo' | 'email'>
    )>>, subscription: Array<(
      { __typename?: 'SubscriptionEntity' }
      & Pick<SubscriptionEntity, 'ID' | 'accountID' | 'subscriptionAmt' | 'noOfUser' | 'salesOrderNo' | 'saleOrderDate' | 'startDate' | 'endDate' | 'implementationDate' | 'modTs' | 'remark' | 'isTerminated' | 'terminationReason' | 'commonStatus' | 'is2FA'>
      & { entityControl?: Maybe<(
        { __typename?: 'EntityControl' }
        & Pick<EntityControl, 'noOfEntity' | 'noofExtraEntity'>
      )>, software: Array<(
        { __typename?: 'SoftwareEntity' }
        & Pick<SoftwareEntity, 'ID' | 'name' | 'code'>
        & { package: Array<(
          { __typename?: 'PackageEntity' }
          & Pick<PackageEntity, 'ID' | 'name'>
        )> }
      )> }
    )> }
  )> }
);

export type GetAccountNameQueryVariables = Exact<{
  ID?: Maybe<Scalars['String']>;
}>;


export type GetAccountNameQuery = (
  { __typename?: 'Query' }
  & { getAccount: Array<(
    { __typename?: 'AccountEntity' }
    & Pick<AccountEntity, 'ID' | 'name' | 'code' | 'commonStatus' | 'contactNo' | 'currencyID' | 'email' | 'regNo' | 'modTs' | 'isInternal' | 'image' | 'imageUrl'>
    & { subscription: Array<(
      { __typename?: 'SubscriptionEntity' }
      & Pick<SubscriptionEntity, 'ID' | 'createdTs' | 'modTs'>
    )> }
  )> }
);

export type GetAccountSubmenuQueryVariables = Exact<{
  ID?: Maybe<Scalars['String']>;
}>;


export type GetAccountSubmenuQuery = (
  { __typename?: 'Query' }
  & { getAccount: Array<(
    { __typename?: 'AccountEntity' }
    & Pick<AccountEntity, 'ID' | 'name' | 'code' | 'contactNo' | 'email' | 'currencyID' | 'regNo' | 'modTs' | 'isInternal' | 'image' | 'imageUrl'>
    & { currency?: Maybe<(
      { __typename?: 'CurrencyNoteEntity' }
      & Pick<CurrencyNoteEntity, 'ID' | 'name' | 'code'>
    )>, address?: Maybe<(
      { __typename?: 'Address' }
      & Pick<Address, 'address' | 'city' | 'state' | 'country' | 'postCode'>
    )>, contactPerson?: Maybe<Array<(
      { __typename?: 'ContactPerson' }
      & Pick<ContactPerson, 'name' | 'designation' | 'contactNo' | 'email'>
    )>>, subscription: Array<(
      { __typename?: 'SubscriptionEntity' }
      & Pick<SubscriptionEntity, 'ID' | 'accountID' | 'subscriptionAmt' | 'noOfUser' | 'salesOrderNo' | 'saleOrderDate' | 'startDate' | 'endDate' | 'implementationDate' | 'modTs' | 'remark' | 'isTerminated' | 'terminationReason' | 'commonStatus' | 'is2FA'>
      & { entityControl?: Maybe<(
        { __typename?: 'EntityControl' }
        & Pick<EntityControl, 'noOfEntity' | 'noofExtraEntity'>
      )>, software: Array<(
        { __typename?: 'SoftwareEntity' }
        & Pick<SoftwareEntity, 'ID' | 'name' | 'code'>
        & { package: Array<(
          { __typename?: 'PackageEntity' }
          & Pick<PackageEntity, 'ID' | 'name'>
        )> }
      )> }
    )> }
  )>, getAllAccount: Array<(
    { __typename?: 'AccountEntity' }
    & Pick<AccountEntity, 'ID' | 'name' | 'code' | 'regNo' | 'isInternal'>
  )> }
);

export type CreateAccountMutationVariables = Exact<{
  input: AccountInput;
}>;


export type CreateAccountMutation = (
  { __typename?: 'Mutation' }
  & { createAccount: (
    { __typename?: 'AccountEntity' }
    & Pick<AccountEntity, 'ID' | 'name' | 'code' | 'email' | 'regNo' | 'contactNo' | 'currencyID' | 'isInternal'>
  ) }
);

export type DeleteAccountMutationVariables = Exact<{
  input: AccountDeleteInput;
}>;


export type DeleteAccountMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'deleteAccount'>
);

export type UpdateAccountMutationVariables = Exact<{
  input: AccountInput;
}>;


export type UpdateAccountMutation = (
  { __typename?: 'Mutation' }
  & { updateAccount: (
    { __typename?: 'AccountEntity' }
    & Pick<AccountEntity, 'ID' | 'name' | 'code'>
  ) }
);

export type UploadAttachmentProductMutationVariables = Exact<{
  file: Scalars['Upload'];
}>;


export type UploadAttachmentProductMutation = (
  { __typename?: 'Mutation' }
  & { UploadAttachmentProduct: (
    { __typename?: 'AzureStorageOutput' }
    & Pick<AzureStorageOutput, 'FileName' | 'Url'>
  ) }
);

export type UploadAttachmentsMutationVariables = Exact<{
  input: AttachmentInput;
}>;


export type UploadAttachmentsMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'uploadAttachments'>
);

export type DeleteAttachmentMutationVariables = Exact<{
  ID?: Maybe<Scalars['String']>;
  refID?: Maybe<Scalars['String']>;
}>;


export type DeleteAttachmentMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'deleteAttachment'>
);

export type AttachmentListingQueryVariables = Exact<{
  ID?: Maybe<Scalars['String']>;
  refID?: Maybe<Scalars['String']>;
  refTable?: Maybe<Scalars['String']>;
}>;


export type AttachmentListingQuery = (
  { __typename?: 'Query' }
  & { AttachmentListing?: Maybe<Array<(
    { __typename?: 'AttachmentEntity' }
    & Pick<AttachmentEntity, 'createdBy' | 'createdTs' | 'ID' | 'description' | 'fileName' | 'fileURL' | 'mediaType' | 'refID' | 'commonStatus'>
  )>> }
);

export type GetLicenseQueryVariables = Exact<{
  subscriptionID: Scalars['String'];
  accountID: Scalars['String'];
}>;


export type GetLicenseQuery = (
  { __typename?: 'Query' }
  & { getLicense?: Maybe<Array<(
    { __typename?: 'LicenseEntity' }
    & Pick<LicenseEntity, 'ID' | 'createdTs' | 'createdBy' | 'modBy' | 'modTs' | 'accountID' | 'commonStatus' | 'subscriptionID' | 'description' | 'hardwareIDs' | 'license' | 'expiryDate' | 'notifyExpiryDate' | 'daysToGo' | 'voidReason'>
    & { entityControl?: Maybe<(
      { __typename?: 'LicenseEntityControl' }
      & Pick<LicenseEntityControl, 'noOfUser' | 'noOfEntity' | 'noofExtraEntity' | 'modules'>
    )> }
  )>> }
);

export type DeactivateLicenseMutationVariables = Exact<{
  subscriptionID: Scalars['String'];
  ID: Scalars['String'];
  Reason: Scalars['String'];
}>;


export type DeactivateLicenseMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'deactivateLicense'>
);

export type GenerateLicenseMutationVariables = Exact<{
  input: LicenseInput;
}>;


export type GenerateLicenseMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'generateLicense'>
);

export type GetSubscriptionQueryVariables = Exact<{
  ID?: Maybe<Scalars['String']>;
  accountID?: Maybe<Scalars['String']>;
  orderByDesc?: Maybe<Scalars['String']>;
}>;


export type GetSubscriptionQuery = (
  { __typename?: 'Query' }
  & { getSubscription: Array<(
    { __typename?: 'SubscriptionEntity' }
    & Pick<SubscriptionEntity, 'ID' | 'accountID' | 'subscriptionAmt' | 'noOfUser' | 'salesOrderNo' | 'saleOrderDate' | 'startDate' | 'endDate' | 'implementationDate' | 'modTs' | 'remark' | 'isTerminated' | 'terminationReason' | 'commonStatus' | 'is2FA'>
    & { entityControl?: Maybe<(
      { __typename?: 'EntityControl' }
      & Pick<EntityControl, 'noOfEntity' | 'noofExtraEntity'>
    )>, software: Array<(
      { __typename?: 'SoftwareEntity' }
      & Pick<SoftwareEntity, 'ID' | 'name' | 'code'>
      & { package: Array<(
        { __typename?: 'PackageEntity' }
        & Pick<PackageEntity, 'ID' | 'name'>
      )> }
    )> }
  )> }
);

export type CreateSubscriptionMutationVariables = Exact<{
  input: SubscriptionInput;
}>;


export type CreateSubscriptionMutation = (
  { __typename?: 'Mutation' }
  & { createSubscription: (
    { __typename?: 'SubscriptionEntity' }
    & Pick<SubscriptionEntity, 'ID' | 'accountID'>
  ) }
);

export type UpdateSubscriptionMutationVariables = Exact<{
  input: SubscriptionUpdateInput;
}>;


export type UpdateSubscriptionMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'updateSubscription'>
);

export type LoginMutationVariables = Exact<{
  password: Scalars['String'];
  loginId: Scalars['String'];
}>;


export type LoginMutation = (
  { __typename?: 'Mutation' }
  & { login: (
    { __typename?: 'LoginResponse' }
    & Pick<LoginResponse, 'accessToken'>
    & { user: (
      { __typename?: 'UserResponse' }
      & Pick<UserResponse, 'ID' | 'name' | 'userName' | 'email' | 'contactNo' | 'department' | 'jobTitle' | 'commonStatus' | 'confirmed' | 'avatar' | 'superUser' | 'accountID' | 'is2FA'>
      & { address?: Maybe<(
        { __typename?: 'Address' }
        & Pick<Address, 'address' | 'city' | 'state' | 'country' | 'postCode'>
      )> }
    ) }
  ) }
);

export type LoggedInUserProfileQueryVariables = Exact<{ [key: string]: never; }>;


export type LoggedInUserProfileQuery = (
  { __typename?: 'Query' }
  & { loggedInUserProfile: (
    { __typename?: 'InternalUserEntity' }
    & Pick<InternalUserEntity, 'ID' | 'name' | 'userName' | 'email' | 'contactNo' | 'department' | 'jobTitle' | 'commonStatus' | 'confirmed' | 'avatar' | 'superUser' | 'is2FA' | 'accountID' | 'roleID'>
    & { address?: Maybe<(
      { __typename?: 'Address' }
      & Pick<Address, 'address' | 'city' | 'state' | 'country' | 'postCode'>
    )> }
  ) }
);

export type LogoutMutationVariables = Exact<{ [key: string]: never; }>;


export type LogoutMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'logout'>
);

export type ChangePasswordMutationVariables = Exact<{
  newPassword: Scalars['String'];
  currentPassword: Scalars['String'];
}>;


export type ChangePasswordMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'changePassword'>
);

export type ActivateUserMutationVariables = Exact<{
  token: Scalars['String'];
}>;


export type ActivateUserMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'activateUser'>
);

export type ForgotPasswordMutationVariables = Exact<{
  email: Scalars['String'];
}>;


export type ForgotPasswordMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'forgotPassword'>
);

export type ResetPasswordMutationVariables = Exact<{
  userID?: Maybe<Scalars['String']>;
  password: Scalars['String'];
  token: Scalars['String'];
}>;


export type ResetPasswordMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'resetPassword'>
);

export type CreatePasswordMutationVariables = Exact<{
  accountID: Scalars['String'];
  userID: Scalars['String'];
  confirmPassword: Scalars['String'];
  password: Scalars['String'];
}>;


export type CreatePasswordMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'createPassword'>
);

export type ChangePwdUnblockUserMutationVariables = Exact<{
  ID: Scalars['String'];
  password: Scalars['String'];
  confirmPassword: Scalars['String'];
}>;


export type ChangePwdUnblockUserMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'changePwdUnblockUser'>
);

export type TwoFaTotpSecretToggleMutationVariables = Exact<{
  is2FAEnable: Scalars['Boolean'];
}>;


export type TwoFaTotpSecretToggleMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'TwoFATotpSecretToggle'>
);

export type TwoFaTotpDetailsQueryVariables = Exact<{ [key: string]: never; }>;


export type TwoFaTotpDetailsQuery = (
  { __typename?: 'Query' }
  & { TwoFATotpDetails: (
    { __typename?: 'TotpSecretTyes' }
    & Pick<TotpSecretTyes, 'is2FA' | 'totpSecret' | 'dataURL' | 'otpURL'>
  ) }
);

export type TotpValidateMutationVariables = Exact<{
  token: Scalars['String'];
}>;


export type TotpValidateMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'totpValidate'>
);

export type GetAllowedOriginQueryVariables = Exact<{
  ID?: Maybe<Scalars['String']>;
  productID?: Maybe<Scalars['String']>;
  origin?: Maybe<Scalars['String']>;
  orderByAsc?: Maybe<Scalars['String']>;
}>;


export type GetAllowedOriginQuery = (
  { __typename?: 'Query' }
  & { getAllowedOrigin: Array<(
    { __typename?: 'AllowedOriginEntity' }
    & Pick<AllowedOriginEntity, 'ID' | 'productID' | 'origin' | 'description' | 'commonStatus'>
    & { product: (
      { __typename?: 'ProductEntity' }
      & Pick<ProductEntity, 'ID' | 'name' | 'code' | 'description'>
    ) }
  )> }
);

export type GetAllowedOriginNameQueryVariables = Exact<{
  ID?: Maybe<Scalars['String']>;
  productID?: Maybe<Scalars['String']>;
  origin?: Maybe<Scalars['String']>;
  orderByAsc?: Maybe<Scalars['String']>;
}>;


export type GetAllowedOriginNameQuery = (
  { __typename?: 'Query' }
  & { getAllowedOrigin: Array<(
    { __typename?: 'AllowedOriginEntity' }
    & Pick<AllowedOriginEntity, 'ID' | 'productID' | 'origin' | 'description' | 'commonStatus'>
  )> }
);

export type CreateAllowedOriginMutationVariables = Exact<{
  input: AllowedOriginInput;
}>;


export type CreateAllowedOriginMutation = (
  { __typename?: 'Mutation' }
  & { createAllowedOrigin: (
    { __typename?: 'AllowedOriginEntity' }
    & Pick<AllowedOriginEntity, 'ID' | 'origin' | 'description' | 'commonStatus'>
  ) }
);

export type UpdateAllowedOriginMutationVariables = Exact<{
  input: AllowedOriginInput;
}>;


export type UpdateAllowedOriginMutation = (
  { __typename?: 'Mutation' }
  & { updateAllowedOrigin: (
    { __typename?: 'AllowedOriginEntity' }
    & Pick<AllowedOriginEntity, 'origin' | 'description' | 'commonStatus'>
  ) }
);

export type DeleteAllowedOriginMutationVariables = Exact<{
  input: AllowedOriginDeleteInput;
}>;


export type DeleteAllowedOriginMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'deleteAllowedOrigin'>
);

export type GetCurrencyQueryVariables = Exact<{
  ID?: Maybe<Scalars['String']>;
  orderByAsc?: Maybe<Scalars['String']>;
}>;


export type GetCurrencyQuery = (
  { __typename?: 'Query' }
  & { getCurrency: Array<(
    { __typename?: 'CurrencyNoteEntity' }
    & Pick<CurrencyNoteEntity, 'ID' | 'code' | 'name' | 'symbol'>
  )> }
);

export type UpdateCurrencyMutationVariables = Exact<{
  input: CurrencyInput;
}>;


export type UpdateCurrencyMutation = (
  { __typename?: 'Mutation' }
  & { updateCurrency: (
    { __typename?: 'CurrencyNoteEntity' }
    & Pick<CurrencyNoteEntity, 'ID' | 'code' | 'name' | 'symbol'>
  ) }
);

export type CreateCurrencyMutationVariables = Exact<{
  input: CurrencyInput;
}>;


export type CreateCurrencyMutation = (
  { __typename?: 'Mutation' }
  & { createCurrency: (
    { __typename?: 'CurrencyNoteEntity' }
    & Pick<CurrencyNoteEntity, 'ID' | 'code' | 'name' | 'symbol'>
  ) }
);

export type DeleteCurrencyMutationVariables = Exact<{
  input: CurrencyDeleteInput;
}>;


export type DeleteCurrencyMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'deleteCurrency'>
);

export type GetCountryQueryVariables = Exact<{
  ID?: Maybe<Scalars['String']>;
}>;


export type GetCountryQuery = (
  { __typename?: 'Query' }
  & { getCountry: Array<(
    { __typename?: 'CountryEntity' }
    & Pick<CountryEntity, 'name' | 'ID'>
  )> }
);

export type GetStatebyCountryQueryVariables = Exact<{
  countryID: Scalars['String'];
}>;


export type GetStatebyCountryQuery = (
  { __typename?: 'Query' }
  & { getStatebyCountry: Array<(
    { __typename?: 'StateEntity' }
    & Pick<StateEntity, 'name' | 'ID'>
  )> }
);

export type GetCitybyStateQueryVariables = Exact<{
  stateID: Scalars['String'];
}>;


export type GetCitybyStateQuery = (
  { __typename?: 'Query' }
  & { getCitybyState: Array<(
    { __typename?: 'CityEntity' }
    & Pick<CityEntity, 'ID' | 'name'>
  )> }
);

export type GetPostcodebyCityQueryVariables = Exact<{
  cityID: Scalars['String'];
}>;


export type GetPostcodebyCityQuery = (
  { __typename?: 'Query' }
  & { getPostcodebyCity: Array<(
    { __typename?: 'PostcodeEntity' }
    & Pick<PostcodeEntity, 'ID' | 'postcode'>
  )> }
);

export type GetModuleQueryVariables = Exact<{
  ID?: Maybe<Scalars['String']>;
  productID?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  orderByAsc?: Maybe<Scalars['String']>;
}>;


export type GetModuleQuery = (
  { __typename?: 'Query' }
  & { getModule: Array<(
    { __typename?: 'ModuleEntity' }
    & Pick<ModuleEntity, 'ID' | 'productID' | 'name' | 'code' | 'sequence' | 'commonStatus'>
    & { product: (
      { __typename?: 'ProductEntity' }
      & Pick<ProductEntity, 'ID' | 'name' | 'code' | 'description'>
    ) }
  )> }
);

export type GetModuleNameQueryVariables = Exact<{
  ID?: Maybe<Scalars['String']>;
  productID?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  orderByAsc?: Maybe<Scalars['String']>;
}>;


export type GetModuleNameQuery = (
  { __typename?: 'Query' }
  & { getModule: Array<(
    { __typename?: 'ModuleEntity' }
    & Pick<ModuleEntity, 'ID' | 'productID' | 'name' | 'code' | 'sequence' | 'commonStatus'>
  )> }
);

export type CreateModuleMutationVariables = Exact<{
  input: ModuleInput;
}>;


export type CreateModuleMutation = (
  { __typename?: 'Mutation' }
  & { createModule: (
    { __typename?: 'ModuleEntity' }
    & Pick<ModuleEntity, 'ID' | 'name' | 'code' | 'sequence' | 'commonStatus'>
  ) }
);

export type UpdateModuleMutationVariables = Exact<{
  input: ModuleInput;
}>;


export type UpdateModuleMutation = (
  { __typename?: 'Mutation' }
  & { updateModule: (
    { __typename?: 'ModuleEntity' }
    & Pick<ModuleEntity, 'name' | 'code' | 'sequence' | 'commonStatus'>
  ) }
);

export type DeleteModuleMutationVariables = Exact<{
  input: ModuleDeleteInput;
}>;


export type DeleteModuleMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'deleteModule'>
);

export type GetProductQueryVariables = Exact<{
  ID?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  orderByAsc?: Maybe<Scalars['String']>;
}>;


export type GetProductQuery = (
  { __typename?: 'Query' }
  & { getProduct: Array<(
    { __typename?: 'ProductEntity' }
    & Pick<ProductEntity, 'ID' | 'name' | 'code' | 'description'>
  )> }
);

export type GetIfcaProductQueryVariables = Exact<{
  ID?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  orderByAsc?: Maybe<Scalars['String']>;
}>;


export type GetIfcaProductQuery = (
  { __typename?: 'Query' }
  & { getIfcaProduct: Array<(
    { __typename?: 'ProductEntity' }
    & Pick<ProductEntity, 'ID' | 'name' | 'code' | 'description'>
  )> }
);

export type CreateProductMutationVariables = Exact<{
  input: ProductInput;
}>;


export type CreateProductMutation = (
  { __typename?: 'Mutation' }
  & { createProduct: (
    { __typename?: 'ProductEntity' }
    & Pick<ProductEntity, 'ID'>
  ) }
);

export type UpdateProductMutationVariables = Exact<{
  input: ProductInput;
}>;


export type UpdateProductMutation = (
  { __typename?: 'Mutation' }
  & { updateProduct: (
    { __typename?: 'ProductEntity' }
    & Pick<ProductEntity, 'ID'>
  ) }
);

export type DeleteProductMutationVariables = Exact<{
  input: ProductDeleteInput;
}>;


export type DeleteProductMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'deleteProduct'>
);

export type DeclareSoftwareCodeEnumQueryVariables = Exact<{
  SoftwareCode: SoftwareCode;
}>;


export type DeclareSoftwareCodeEnumQuery = (
  { __typename?: 'Query' }
  & Pick<Query, 'declareSoftwareCodeEnum'>
);

export type DeclareSoftwarePackagesEnumQueryVariables = Exact<{
  ContractPackage: ContractPackage;
  HotelPackage: HotelPackage;
  HRPackage: HrPackage;
  IfcaPackage: IfcaPackage;
  MenuPackages: MenuPackages;
  PropertyPackages: PropertyPackages;
  ReportDesignerPackage: ReportDesignerPackage;
  AccountPackage: AccountPackage;
  EinvoicePackages: EinvoicePackages;
}>;


export type DeclareSoftwarePackagesEnumQuery = (
  { __typename?: 'Query' }
  & Pick<Query, 'declareSoftwarePackagesEnum'>
);

export type GetAccountsBySoftwareCodeQueryVariables = Exact<{
  softwareCode: Scalars['String'];
}>;


export type GetAccountsBySoftwareCodeQuery = (
  { __typename?: 'Query' }
  & { getAccountsBySoftwareCodeForUser: Array<(
    { __typename?: 'AccountEntity' }
    & Pick<AccountEntity, 'ID' | 'name' | 'code' | 'isInternal' | 'latestSubscription'>
  )> }
);

export type GetProductInformationCenterQueryVariables = Exact<{ [key: string]: never; }>;


export type GetProductInformationCenterQuery = (
  { __typename?: 'Query' }
  & { getProductForUser: Array<(
    { __typename?: 'ProductEntity' }
    & Pick<ProductEntity, 'ID' | 'name' | 'code' | 'description'>
  )> }
);

export type GetRoleListQueryVariables = Exact<{ [key: string]: never; }>;


export type GetRoleListQuery = (
  { __typename?: 'Query' }
  & { getRole: Array<(
    { __typename?: 'RoleEntity' }
    & Pick<RoleEntity, 'ID' | 'name' | 'commonStatus'>
  )> }
);

export type GetRoleByIdQueryVariables = Exact<{
  ID: Scalars['String'];
}>;


export type GetRoleByIdQuery = (
  { __typename?: 'Query' }
  & { getRole: Array<(
    { __typename?: 'RoleEntity' }
    & Pick<RoleEntity, 'ID' | 'name' | 'commonStatus'>
    & { roleProduct?: Maybe<Array<(
      { __typename?: 'RoleProductEntity' }
      & Pick<RoleProductEntity, 'ID' | 'roleID' | 'productID' | 'productCode'>
    )>>, roleAccount?: Maybe<Array<(
      { __typename?: 'RoleAccountEntity' }
      & Pick<RoleAccountEntity, 'ID' | 'roleID' | 'accountID'>
      & { account?: Maybe<(
        { __typename?: 'AccountEntity' }
        & Pick<AccountEntity, 'name' | 'code'>
      )> }
    )>> }
  )> }
);

export type GetRoleAccountQueryVariables = Exact<{
  roleID: Scalars['String'];
}>;


export type GetRoleAccountQuery = (
  { __typename?: 'Query' }
  & { getRoleAccount: Array<(
    { __typename?: 'RoleAccountEntity' }
    & Pick<RoleAccountEntity, 'ID' | 'roleID' | 'accountID'>
    & { account?: Maybe<(
      { __typename?: 'AccountEntity' }
      & Pick<AccountEntity, 'name' | 'code'>
    )> }
  )> }
);

export type GetRoleProductQueryVariables = Exact<{
  roleID: Scalars['String'];
}>;


export type GetRoleProductQuery = (
  { __typename?: 'Query' }
  & { getRoleProduct: Array<(
    { __typename?: 'RoleProductEntity' }
    & Pick<RoleProductEntity, 'ID' | 'roleID' | 'productID' | 'productCode'>
  )> }
);

export type CreateRoleMutationVariables = Exact<{
  input: RoleInput;
}>;


export type CreateRoleMutation = (
  { __typename?: 'Mutation' }
  & { createRole: (
    { __typename?: 'RoleEntity' }
    & Pick<RoleEntity, 'ID'>
  ) }
);

export type UpdateRoleMutationVariables = Exact<{
  input: RoleInput;
}>;


export type UpdateRoleMutation = (
  { __typename?: 'Mutation' }
  & { updateRole: (
    { __typename?: 'RoleEntity' }
    & Pick<RoleEntity, 'ID'>
  ) }
);

export type DeleteRoleMutationVariables = Exact<{
  ID: Scalars['String'];
}>;


export type DeleteRoleMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'deleteRole'>
);

export type AssignRoleAccountMutationVariables = Exact<{
  input: RoleAccountAssignmentInput;
}>;


export type AssignRoleAccountMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'assignRoleAccount'>
);

export type UnAssignRoleAccountMutationVariables = Exact<{
  input: RoleAccountAssignmentInput;
}>;


export type UnAssignRoleAccountMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'unAssignRoleAccount'>
);

export type AssignRoleProductMutationVariables = Exact<{
  input: RoleProductAssignmentInput;
}>;


export type AssignRoleProductMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'assignRoleProduct'>
);

export type UnAssignRoleProductMutationVariables = Exact<{
  input: RoleProductAssignmentInput;
}>;


export type UnAssignRoleProductMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'unAssignRoleProduct'>
);

export type GetUserQueryVariables = Exact<{
  ID: Scalars['String'];
}>;


export type GetUserQuery = (
  { __typename?: 'Query' }
  & { getUser: (
    { __typename?: 'InternalUserEntity' }
    & Pick<InternalUserEntity, 'ID' | 'name' | 'department' | 'email' | 'jobTitle' | 'contactNo' | 'superUser' | 'commonStatus' | 'userName' | 'roleID'>
  ) }
);

export type GetUsersByAccountQueryVariables = Exact<{
  accountID: Scalars['String'];
  status?: Maybe<CommonStatus>;
}>;


export type GetUsersByAccountQuery = (
  { __typename?: 'Query' }
  & { getUsersByAccount: Array<(
    { __typename?: 'InternalUserEntity' }
    & Pick<InternalUserEntity, 'ID' | 'userName' | 'email' | 'contactNo' | 'commonStatus' | 'confirmed' | 'avatar' | 'superUser' | 'accountID' | 'softwareCode' | 'name' | 'department' | 'jobTitle' | 'roleID'>
  )> }
);

export type CreateUserMutationVariables = Exact<{
  input: UserInput;
}>;


export type CreateUserMutation = (
  { __typename?: 'Mutation' }
  & { createUser: (
    { __typename?: 'InternalUserEntity' }
    & Pick<InternalUserEntity, 'ID' | 'email'>
  ) }
);

export type UpdateUserMutationVariables = Exact<{
  input: UserInput;
}>;


export type UpdateUserMutation = (
  { __typename?: 'Mutation' }
  & { updateUser: (
    { __typename?: 'InternalUserEntity' }
    & Pick<InternalUserEntity, 'ID'>
  ) }
);


export const GetAccountDocument = gql`
    query getAccount($ID: String) {
  getAccount(ID: $ID) {
    ID
    name
    code
    contactNo
    email
    currencyID
    commonStatus
    currency {
      ID
      name
      code
    }
    regNo
    modTs
    isInternal
    image
    imageUrl
    address {
      address
      city
      state
      country
      postCode
    }
    contactPerson {
      name
      designation
      contactNo
      email
    }
    subscription {
      ID
      accountID
      subscriptionAmt
      noOfUser
      salesOrderNo
      saleOrderDate
      startDate
      endDate
      implementationDate
      modTs
      remark
      isTerminated
      terminationReason
      commonStatus
      is2FA
      entityControl {
        noOfEntity
        noofExtraEntity
      }
      software {
        ID
        name
        code
        package {
          ID
          name
        }
      }
    }
  }
}
    `;

/**
 * __useGetAccountQuery__
 *
 * To run a query within a React component, call `useGetAccountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAccountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAccountQuery({
 *   variables: {
 *      ID: // value for 'ID'
 *   },
 * });
 */
export function useGetAccountQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetAccountQuery, GetAccountQueryVariables>) {
        return ApolloReactHooks.useQuery<GetAccountQuery, GetAccountQueryVariables>(GetAccountDocument, baseOptions);
      }
export function useGetAccountLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetAccountQuery, GetAccountQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetAccountQuery, GetAccountQueryVariables>(GetAccountDocument, baseOptions);
        }
export type GetAccountQueryHookResult = ReturnType<typeof useGetAccountQuery>;
export type GetAccountLazyQueryHookResult = ReturnType<typeof useGetAccountLazyQuery>;
export type GetAccountQueryResult = ApolloReactCommon.QueryResult<GetAccountQuery, GetAccountQueryVariables>;
export const GetAccountNameDocument = gql`
    query getAccountName($ID: String) {
  getAccount(ID: $ID) {
    ID
    name
    code
    commonStatus
    contactNo
    currencyID
    email
    regNo
    modTs
    isInternal
    image
    imageUrl
    subscription {
      ID
      createdTs
      modTs
    }
  }
}
    `;

/**
 * __useGetAccountNameQuery__
 *
 * To run a query within a React component, call `useGetAccountNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAccountNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAccountNameQuery({
 *   variables: {
 *      ID: // value for 'ID'
 *   },
 * });
 */
export function useGetAccountNameQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetAccountNameQuery, GetAccountNameQueryVariables>) {
        return ApolloReactHooks.useQuery<GetAccountNameQuery, GetAccountNameQueryVariables>(GetAccountNameDocument, baseOptions);
      }
export function useGetAccountNameLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetAccountNameQuery, GetAccountNameQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetAccountNameQuery, GetAccountNameQueryVariables>(GetAccountNameDocument, baseOptions);
        }
export type GetAccountNameQueryHookResult = ReturnType<typeof useGetAccountNameQuery>;
export type GetAccountNameLazyQueryHookResult = ReturnType<typeof useGetAccountNameLazyQuery>;
export type GetAccountNameQueryResult = ApolloReactCommon.QueryResult<GetAccountNameQuery, GetAccountNameQueryVariables>;
export const GetAccountSubmenuDocument = gql`
    query getAccountSubmenu($ID: String) {
  getAccount(ID: $ID) {
    ID
    name
    code
    contactNo
    email
    currencyID
    currency {
      ID
      name
      code
    }
    regNo
    modTs
    isInternal
    image
    imageUrl
    address {
      address
      city
      state
      country
      postCode
    }
    contactPerson {
      name
      designation
      contactNo
      email
    }
    subscription {
      ID
      accountID
      subscriptionAmt
      noOfUser
      salesOrderNo
      saleOrderDate
      startDate
      endDate
      implementationDate
      modTs
      remark
      isTerminated
      terminationReason
      commonStatus
      is2FA
      entityControl {
        noOfEntity
        noofExtraEntity
      }
      software {
        ID
        name
        code
        package {
          ID
          name
        }
      }
    }
  }
  getAllAccount: getAccount {
    ID
    name
    code
    regNo
    isInternal
  }
}
    `;

/**
 * __useGetAccountSubmenuQuery__
 *
 * To run a query within a React component, call `useGetAccountSubmenuQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAccountSubmenuQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAccountSubmenuQuery({
 *   variables: {
 *      ID: // value for 'ID'
 *   },
 * });
 */
export function useGetAccountSubmenuQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetAccountSubmenuQuery, GetAccountSubmenuQueryVariables>) {
        return ApolloReactHooks.useQuery<GetAccountSubmenuQuery, GetAccountSubmenuQueryVariables>(GetAccountSubmenuDocument, baseOptions);
      }
export function useGetAccountSubmenuLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetAccountSubmenuQuery, GetAccountSubmenuQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetAccountSubmenuQuery, GetAccountSubmenuQueryVariables>(GetAccountSubmenuDocument, baseOptions);
        }
export type GetAccountSubmenuQueryHookResult = ReturnType<typeof useGetAccountSubmenuQuery>;
export type GetAccountSubmenuLazyQueryHookResult = ReturnType<typeof useGetAccountSubmenuLazyQuery>;
export type GetAccountSubmenuQueryResult = ApolloReactCommon.QueryResult<GetAccountSubmenuQuery, GetAccountSubmenuQueryVariables>;
export const CreateAccountDocument = gql`
    mutation createAccount($input: AccountInput!) {
  createAccount(input: $input) {
    ID
    name
    code
    email
    regNo
    contactNo
    currencyID
    isInternal
  }
}
    `;
export type CreateAccountMutationFn = ApolloReactCommon.MutationFunction<CreateAccountMutation, CreateAccountMutationVariables>;

/**
 * __useCreateAccountMutation__
 *
 * To run a mutation, you first call `useCreateAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAccountMutation, { data, loading, error }] = useCreateAccountMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateAccountMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateAccountMutation, CreateAccountMutationVariables>) {
        return ApolloReactHooks.useMutation<CreateAccountMutation, CreateAccountMutationVariables>(CreateAccountDocument, baseOptions);
      }
export type CreateAccountMutationHookResult = ReturnType<typeof useCreateAccountMutation>;
export type CreateAccountMutationResult = ApolloReactCommon.MutationResult<CreateAccountMutation>;
export type CreateAccountMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateAccountMutation, CreateAccountMutationVariables>;
export const DeleteAccountDocument = gql`
    mutation deleteAccount($input: AccountDeleteInput!) {
  deleteAccount(input: $input)
}
    `;
export type DeleteAccountMutationFn = ApolloReactCommon.MutationFunction<DeleteAccountMutation, DeleteAccountMutationVariables>;

/**
 * __useDeleteAccountMutation__
 *
 * To run a mutation, you first call `useDeleteAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAccountMutation, { data, loading, error }] = useDeleteAccountMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteAccountMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteAccountMutation, DeleteAccountMutationVariables>) {
        return ApolloReactHooks.useMutation<DeleteAccountMutation, DeleteAccountMutationVariables>(DeleteAccountDocument, baseOptions);
      }
export type DeleteAccountMutationHookResult = ReturnType<typeof useDeleteAccountMutation>;
export type DeleteAccountMutationResult = ApolloReactCommon.MutationResult<DeleteAccountMutation>;
export type DeleteAccountMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteAccountMutation, DeleteAccountMutationVariables>;
export const UpdateAccountDocument = gql`
    mutation updateAccount($input: AccountInput!) {
  updateAccount(input: $input) {
    ID
    name
    code
  }
}
    `;
export type UpdateAccountMutationFn = ApolloReactCommon.MutationFunction<UpdateAccountMutation, UpdateAccountMutationVariables>;

/**
 * __useUpdateAccountMutation__
 *
 * To run a mutation, you first call `useUpdateAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAccountMutation, { data, loading, error }] = useUpdateAccountMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAccountMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateAccountMutation, UpdateAccountMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdateAccountMutation, UpdateAccountMutationVariables>(UpdateAccountDocument, baseOptions);
      }
export type UpdateAccountMutationHookResult = ReturnType<typeof useUpdateAccountMutation>;
export type UpdateAccountMutationResult = ApolloReactCommon.MutationResult<UpdateAccountMutation>;
export type UpdateAccountMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateAccountMutation, UpdateAccountMutationVariables>;
export const UploadAttachmentProductDocument = gql`
    mutation UploadAttachmentProduct($file: Upload!) {
  UploadAttachmentProduct(file: $file) {
    FileName
    Url
  }
}
    `;
export type UploadAttachmentProductMutationFn = ApolloReactCommon.MutationFunction<UploadAttachmentProductMutation, UploadAttachmentProductMutationVariables>;

/**
 * __useUploadAttachmentProductMutation__
 *
 * To run a mutation, you first call `useUploadAttachmentProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadAttachmentProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadAttachmentProductMutation, { data, loading, error }] = useUploadAttachmentProductMutation({
 *   variables: {
 *      file: // value for 'file'
 *   },
 * });
 */
export function useUploadAttachmentProductMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UploadAttachmentProductMutation, UploadAttachmentProductMutationVariables>) {
        return ApolloReactHooks.useMutation<UploadAttachmentProductMutation, UploadAttachmentProductMutationVariables>(UploadAttachmentProductDocument, baseOptions);
      }
export type UploadAttachmentProductMutationHookResult = ReturnType<typeof useUploadAttachmentProductMutation>;
export type UploadAttachmentProductMutationResult = ApolloReactCommon.MutationResult<UploadAttachmentProductMutation>;
export type UploadAttachmentProductMutationOptions = ApolloReactCommon.BaseMutationOptions<UploadAttachmentProductMutation, UploadAttachmentProductMutationVariables>;
export const UploadAttachmentsDocument = gql`
    mutation uploadAttachments($input: AttachmentInput!) {
  uploadAttachments(input: $input)
}
    `;
export type UploadAttachmentsMutationFn = ApolloReactCommon.MutationFunction<UploadAttachmentsMutation, UploadAttachmentsMutationVariables>;

/**
 * __useUploadAttachmentsMutation__
 *
 * To run a mutation, you first call `useUploadAttachmentsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadAttachmentsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadAttachmentsMutation, { data, loading, error }] = useUploadAttachmentsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUploadAttachmentsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UploadAttachmentsMutation, UploadAttachmentsMutationVariables>) {
        return ApolloReactHooks.useMutation<UploadAttachmentsMutation, UploadAttachmentsMutationVariables>(UploadAttachmentsDocument, baseOptions);
      }
export type UploadAttachmentsMutationHookResult = ReturnType<typeof useUploadAttachmentsMutation>;
export type UploadAttachmentsMutationResult = ApolloReactCommon.MutationResult<UploadAttachmentsMutation>;
export type UploadAttachmentsMutationOptions = ApolloReactCommon.BaseMutationOptions<UploadAttachmentsMutation, UploadAttachmentsMutationVariables>;
export const DeleteAttachmentDocument = gql`
    mutation deleteAttachment($ID: String, $refID: String) {
  deleteAttachment(ID: $ID, refID: $refID)
}
    `;
export type DeleteAttachmentMutationFn = ApolloReactCommon.MutationFunction<DeleteAttachmentMutation, DeleteAttachmentMutationVariables>;

/**
 * __useDeleteAttachmentMutation__
 *
 * To run a mutation, you first call `useDeleteAttachmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAttachmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAttachmentMutation, { data, loading, error }] = useDeleteAttachmentMutation({
 *   variables: {
 *      ID: // value for 'ID'
 *      refID: // value for 'refID'
 *   },
 * });
 */
export function useDeleteAttachmentMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteAttachmentMutation, DeleteAttachmentMutationVariables>) {
        return ApolloReactHooks.useMutation<DeleteAttachmentMutation, DeleteAttachmentMutationVariables>(DeleteAttachmentDocument, baseOptions);
      }
export type DeleteAttachmentMutationHookResult = ReturnType<typeof useDeleteAttachmentMutation>;
export type DeleteAttachmentMutationResult = ApolloReactCommon.MutationResult<DeleteAttachmentMutation>;
export type DeleteAttachmentMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteAttachmentMutation, DeleteAttachmentMutationVariables>;
export const AttachmentListingDocument = gql`
    query AttachmentListing($ID: String, $refID: String, $refTable: String) {
  AttachmentListing(ID: $ID, refID: $refID, refTable: $refTable) {
    createdBy
    createdTs
    ID
    description
    fileName
    fileURL
    mediaType
    refID
    commonStatus
  }
}
    `;

/**
 * __useAttachmentListingQuery__
 *
 * To run a query within a React component, call `useAttachmentListingQuery` and pass it any options that fit your needs.
 * When your component renders, `useAttachmentListingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAttachmentListingQuery({
 *   variables: {
 *      ID: // value for 'ID'
 *      refID: // value for 'refID'
 *      refTable: // value for 'refTable'
 *   },
 * });
 */
export function useAttachmentListingQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<AttachmentListingQuery, AttachmentListingQueryVariables>) {
        return ApolloReactHooks.useQuery<AttachmentListingQuery, AttachmentListingQueryVariables>(AttachmentListingDocument, baseOptions);
      }
export function useAttachmentListingLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AttachmentListingQuery, AttachmentListingQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<AttachmentListingQuery, AttachmentListingQueryVariables>(AttachmentListingDocument, baseOptions);
        }
export type AttachmentListingQueryHookResult = ReturnType<typeof useAttachmentListingQuery>;
export type AttachmentListingLazyQueryHookResult = ReturnType<typeof useAttachmentListingLazyQuery>;
export type AttachmentListingQueryResult = ApolloReactCommon.QueryResult<AttachmentListingQuery, AttachmentListingQueryVariables>;
export const GetLicenseDocument = gql`
    query getLicense($subscriptionID: String!, $accountID: String!) {
  getLicense(subscriptionID: $subscriptionID, accountID: $accountID) {
    ID
    createdTs
    createdBy
    modBy
    modTs
    accountID
    commonStatus
    subscriptionID
    description
    hardwareIDs
    license
    expiryDate
    notifyExpiryDate
    daysToGo
    voidReason
    entityControl {
      noOfUser
      noOfEntity
      noofExtraEntity
      modules
    }
  }
}
    `;

/**
 * __useGetLicenseQuery__
 *
 * To run a query within a React component, call `useGetLicenseQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLicenseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLicenseQuery({
 *   variables: {
 *      subscriptionID: // value for 'subscriptionID'
 *      accountID: // value for 'accountID'
 *   },
 * });
 */
export function useGetLicenseQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetLicenseQuery, GetLicenseQueryVariables>) {
        return ApolloReactHooks.useQuery<GetLicenseQuery, GetLicenseQueryVariables>(GetLicenseDocument, baseOptions);
      }
export function useGetLicenseLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetLicenseQuery, GetLicenseQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetLicenseQuery, GetLicenseQueryVariables>(GetLicenseDocument, baseOptions);
        }
export type GetLicenseQueryHookResult = ReturnType<typeof useGetLicenseQuery>;
export type GetLicenseLazyQueryHookResult = ReturnType<typeof useGetLicenseLazyQuery>;
export type GetLicenseQueryResult = ApolloReactCommon.QueryResult<GetLicenseQuery, GetLicenseQueryVariables>;
export const DeactivateLicenseDocument = gql`
    mutation deactivateLicense($subscriptionID: String!, $ID: String!, $Reason: String!) {
  deactivateLicense(ID: $ID, subscriptionID: $subscriptionID, reason: $Reason)
}
    `;
export type DeactivateLicenseMutationFn = ApolloReactCommon.MutationFunction<DeactivateLicenseMutation, DeactivateLicenseMutationVariables>;

/**
 * __useDeactivateLicenseMutation__
 *
 * To run a mutation, you first call `useDeactivateLicenseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeactivateLicenseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deactivateLicenseMutation, { data, loading, error }] = useDeactivateLicenseMutation({
 *   variables: {
 *      subscriptionID: // value for 'subscriptionID'
 *      ID: // value for 'ID'
 *      Reason: // value for 'Reason'
 *   },
 * });
 */
export function useDeactivateLicenseMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeactivateLicenseMutation, DeactivateLicenseMutationVariables>) {
        return ApolloReactHooks.useMutation<DeactivateLicenseMutation, DeactivateLicenseMutationVariables>(DeactivateLicenseDocument, baseOptions);
      }
export type DeactivateLicenseMutationHookResult = ReturnType<typeof useDeactivateLicenseMutation>;
export type DeactivateLicenseMutationResult = ApolloReactCommon.MutationResult<DeactivateLicenseMutation>;
export type DeactivateLicenseMutationOptions = ApolloReactCommon.BaseMutationOptions<DeactivateLicenseMutation, DeactivateLicenseMutationVariables>;
export const GenerateLicenseDocument = gql`
    mutation generateLicense($input: LicenseInput!) {
  generateLicense(input: $input)
}
    `;
export type GenerateLicenseMutationFn = ApolloReactCommon.MutationFunction<GenerateLicenseMutation, GenerateLicenseMutationVariables>;

/**
 * __useGenerateLicenseMutation__
 *
 * To run a mutation, you first call `useGenerateLicenseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateLicenseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateLicenseMutation, { data, loading, error }] = useGenerateLicenseMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGenerateLicenseMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<GenerateLicenseMutation, GenerateLicenseMutationVariables>) {
        return ApolloReactHooks.useMutation<GenerateLicenseMutation, GenerateLicenseMutationVariables>(GenerateLicenseDocument, baseOptions);
      }
export type GenerateLicenseMutationHookResult = ReturnType<typeof useGenerateLicenseMutation>;
export type GenerateLicenseMutationResult = ApolloReactCommon.MutationResult<GenerateLicenseMutation>;
export type GenerateLicenseMutationOptions = ApolloReactCommon.BaseMutationOptions<GenerateLicenseMutation, GenerateLicenseMutationVariables>;
export const GetSubscriptionDocument = gql`
    query getSubscription($ID: String, $accountID: String, $orderByDesc: String) {
  getSubscription(ID: $ID, accountID: $accountID, orderByDesc: $orderByDesc) {
    ID
    accountID
    subscriptionAmt
    noOfUser
    salesOrderNo
    saleOrderDate
    startDate
    endDate
    implementationDate
    modTs
    remark
    isTerminated
    terminationReason
    commonStatus
    is2FA
    entityControl {
      noOfEntity
      noofExtraEntity
    }
    software {
      ID
      name
      code
      package {
        ID
        name
      }
    }
  }
}
    `;

/**
 * __useGetSubscriptionQuery__
 *
 * To run a query within a React component, call `useGetSubscriptionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSubscriptionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSubscriptionQuery({
 *   variables: {
 *      ID: // value for 'ID'
 *      accountID: // value for 'accountID'
 *      orderByDesc: // value for 'orderByDesc'
 *   },
 * });
 */
export function useGetSubscriptionQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetSubscriptionQuery, GetSubscriptionQueryVariables>) {
        return ApolloReactHooks.useQuery<GetSubscriptionQuery, GetSubscriptionQueryVariables>(GetSubscriptionDocument, baseOptions);
      }
export function useGetSubscriptionLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetSubscriptionQuery, GetSubscriptionQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetSubscriptionQuery, GetSubscriptionQueryVariables>(GetSubscriptionDocument, baseOptions);
        }
export type GetSubscriptionQueryHookResult = ReturnType<typeof useGetSubscriptionQuery>;
export type GetSubscriptionLazyQueryHookResult = ReturnType<typeof useGetSubscriptionLazyQuery>;
export type GetSubscriptionQueryResult = ApolloReactCommon.QueryResult<GetSubscriptionQuery, GetSubscriptionQueryVariables>;
export const CreateSubscriptionDocument = gql`
    mutation createSubscription($input: SubscriptionInput!) {
  createSubscription(input: $input) {
    ID
    accountID
  }
}
    `;
export type CreateSubscriptionMutationFn = ApolloReactCommon.MutationFunction<CreateSubscriptionMutation, CreateSubscriptionMutationVariables>;

/**
 * __useCreateSubscriptionMutation__
 *
 * To run a mutation, you first call `useCreateSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSubscriptionMutation, { data, loading, error }] = useCreateSubscriptionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateSubscriptionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateSubscriptionMutation, CreateSubscriptionMutationVariables>) {
        return ApolloReactHooks.useMutation<CreateSubscriptionMutation, CreateSubscriptionMutationVariables>(CreateSubscriptionDocument, baseOptions);
      }
export type CreateSubscriptionMutationHookResult = ReturnType<typeof useCreateSubscriptionMutation>;
export type CreateSubscriptionMutationResult = ApolloReactCommon.MutationResult<CreateSubscriptionMutation>;
export type CreateSubscriptionMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateSubscriptionMutation, CreateSubscriptionMutationVariables>;
export const UpdateSubscriptionDocument = gql`
    mutation updateSubscription($input: SubscriptionUpdateInput!) {
  updateSubscription(input: $input)
}
    `;
export type UpdateSubscriptionMutationFn = ApolloReactCommon.MutationFunction<UpdateSubscriptionMutation, UpdateSubscriptionMutationVariables>;

/**
 * __useUpdateSubscriptionMutation__
 *
 * To run a mutation, you first call `useUpdateSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSubscriptionMutation, { data, loading, error }] = useUpdateSubscriptionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateSubscriptionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateSubscriptionMutation, UpdateSubscriptionMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdateSubscriptionMutation, UpdateSubscriptionMutationVariables>(UpdateSubscriptionDocument, baseOptions);
      }
export type UpdateSubscriptionMutationHookResult = ReturnType<typeof useUpdateSubscriptionMutation>;
export type UpdateSubscriptionMutationResult = ApolloReactCommon.MutationResult<UpdateSubscriptionMutation>;
export type UpdateSubscriptionMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateSubscriptionMutation, UpdateSubscriptionMutationVariables>;
export const LoginDocument = gql`
    mutation Login($password: String!, $loginId: String!) {
  login(password: $password, loginId: $loginId) {
    accessToken
    user {
      ID
      name
      userName
      email
      contactNo
      address {
        address
        city
        state
        country
        postCode
      }
      department
      jobTitle
      commonStatus
      confirmed
      avatar
      superUser
      accountID
      is2FA
    }
  }
}
    `;
export type LoginMutationFn = ApolloReactCommon.MutationFunction<LoginMutation, LoginMutationVariables>;

/**
 * __useLoginMutation__
 *
 * To run a mutation, you first call `useLoginMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLoginMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [loginMutation, { data, loading, error }] = useLoginMutation({
 *   variables: {
 *      password: // value for 'password'
 *      loginId: // value for 'loginId'
 *   },
 * });
 */
export function useLoginMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<LoginMutation, LoginMutationVariables>) {
        return ApolloReactHooks.useMutation<LoginMutation, LoginMutationVariables>(LoginDocument, baseOptions);
      }
export type LoginMutationHookResult = ReturnType<typeof useLoginMutation>;
export type LoginMutationResult = ApolloReactCommon.MutationResult<LoginMutation>;
export type LoginMutationOptions = ApolloReactCommon.BaseMutationOptions<LoginMutation, LoginMutationVariables>;
export const LoggedInUserProfileDocument = gql`
    query loggedInUserProfile {
  loggedInUserProfile {
    ID
    name
    userName
    email
    contactNo
    address {
      address
      city
      state
      country
      postCode
    }
    department
    jobTitle
    commonStatus
    confirmed
    avatar
    superUser
    is2FA
    accountID
    roleID
  }
}
    `;

/**
 * __useLoggedInUserProfileQuery__
 *
 * To run a query within a React component, call `useLoggedInUserProfileQuery` and pass it any options that fit your needs.
 * When your component renders, `useLoggedInUserProfileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLoggedInUserProfileQuery({
 *   variables: {
 *   },
 * });
 */
export function useLoggedInUserProfileQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<LoggedInUserProfileQuery, LoggedInUserProfileQueryVariables>) {
        return ApolloReactHooks.useQuery<LoggedInUserProfileQuery, LoggedInUserProfileQueryVariables>(LoggedInUserProfileDocument, baseOptions);
      }
export function useLoggedInUserProfileLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<LoggedInUserProfileQuery, LoggedInUserProfileQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<LoggedInUserProfileQuery, LoggedInUserProfileQueryVariables>(LoggedInUserProfileDocument, baseOptions);
        }
export type LoggedInUserProfileQueryHookResult = ReturnType<typeof useLoggedInUserProfileQuery>;
export type LoggedInUserProfileLazyQueryHookResult = ReturnType<typeof useLoggedInUserProfileLazyQuery>;
export type LoggedInUserProfileQueryResult = ApolloReactCommon.QueryResult<LoggedInUserProfileQuery, LoggedInUserProfileQueryVariables>;
export const LogoutDocument = gql`
    mutation logout {
  logout
}
    `;
export type LogoutMutationFn = ApolloReactCommon.MutationFunction<LogoutMutation, LogoutMutationVariables>;

/**
 * __useLogoutMutation__
 *
 * To run a mutation, you first call `useLogoutMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLogoutMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [logoutMutation, { data, loading, error }] = useLogoutMutation({
 *   variables: {
 *   },
 * });
 */
export function useLogoutMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<LogoutMutation, LogoutMutationVariables>) {
        return ApolloReactHooks.useMutation<LogoutMutation, LogoutMutationVariables>(LogoutDocument, baseOptions);
      }
export type LogoutMutationHookResult = ReturnType<typeof useLogoutMutation>;
export type LogoutMutationResult = ApolloReactCommon.MutationResult<LogoutMutation>;
export type LogoutMutationOptions = ApolloReactCommon.BaseMutationOptions<LogoutMutation, LogoutMutationVariables>;
export const ChangePasswordDocument = gql`
    mutation changePassword($newPassword: String!, $currentPassword: String!) {
  changePassword(newPassword: $newPassword, currentPassword: $currentPassword)
}
    `;
export type ChangePasswordMutationFn = ApolloReactCommon.MutationFunction<ChangePasswordMutation, ChangePasswordMutationVariables>;

/**
 * __useChangePasswordMutation__
 *
 * To run a mutation, you first call `useChangePasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangePasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changePasswordMutation, { data, loading, error }] = useChangePasswordMutation({
 *   variables: {
 *      newPassword: // value for 'newPassword'
 *      currentPassword: // value for 'currentPassword'
 *   },
 * });
 */
export function useChangePasswordMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ChangePasswordMutation, ChangePasswordMutationVariables>) {
        return ApolloReactHooks.useMutation<ChangePasswordMutation, ChangePasswordMutationVariables>(ChangePasswordDocument, baseOptions);
      }
export type ChangePasswordMutationHookResult = ReturnType<typeof useChangePasswordMutation>;
export type ChangePasswordMutationResult = ApolloReactCommon.MutationResult<ChangePasswordMutation>;
export type ChangePasswordMutationOptions = ApolloReactCommon.BaseMutationOptions<ChangePasswordMutation, ChangePasswordMutationVariables>;
export const ActivateUserDocument = gql`
    mutation activateUser($token: String!) {
  activateUser(token: $token)
}
    `;
export type ActivateUserMutationFn = ApolloReactCommon.MutationFunction<ActivateUserMutation, ActivateUserMutationVariables>;

/**
 * __useActivateUserMutation__
 *
 * To run a mutation, you first call `useActivateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useActivateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [activateUserMutation, { data, loading, error }] = useActivateUserMutation({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function useActivateUserMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ActivateUserMutation, ActivateUserMutationVariables>) {
        return ApolloReactHooks.useMutation<ActivateUserMutation, ActivateUserMutationVariables>(ActivateUserDocument, baseOptions);
      }
export type ActivateUserMutationHookResult = ReturnType<typeof useActivateUserMutation>;
export type ActivateUserMutationResult = ApolloReactCommon.MutationResult<ActivateUserMutation>;
export type ActivateUserMutationOptions = ApolloReactCommon.BaseMutationOptions<ActivateUserMutation, ActivateUserMutationVariables>;
export const ForgotPasswordDocument = gql`
    mutation forgotPassword($email: String!) {
  forgotPassword(email: $email)
}
    `;
export type ForgotPasswordMutationFn = ApolloReactCommon.MutationFunction<ForgotPasswordMutation, ForgotPasswordMutationVariables>;

/**
 * __useForgotPasswordMutation__
 *
 * To run a mutation, you first call `useForgotPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useForgotPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [forgotPasswordMutation, { data, loading, error }] = useForgotPasswordMutation({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useForgotPasswordMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ForgotPasswordMutation, ForgotPasswordMutationVariables>) {
        return ApolloReactHooks.useMutation<ForgotPasswordMutation, ForgotPasswordMutationVariables>(ForgotPasswordDocument, baseOptions);
      }
export type ForgotPasswordMutationHookResult = ReturnType<typeof useForgotPasswordMutation>;
export type ForgotPasswordMutationResult = ApolloReactCommon.MutationResult<ForgotPasswordMutation>;
export type ForgotPasswordMutationOptions = ApolloReactCommon.BaseMutationOptions<ForgotPasswordMutation, ForgotPasswordMutationVariables>;
export const ResetPasswordDocument = gql`
    mutation resetPassword($userID: String, $password: String!, $token: String!) {
  resetPassword(userID: $userID, password: $password, token: $token)
}
    `;
export type ResetPasswordMutationFn = ApolloReactCommon.MutationFunction<ResetPasswordMutation, ResetPasswordMutationVariables>;

/**
 * __useResetPasswordMutation__
 *
 * To run a mutation, you first call `useResetPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetPasswordMutation, { data, loading, error }] = useResetPasswordMutation({
 *   variables: {
 *      userID: // value for 'userID'
 *      password: // value for 'password'
 *      token: // value for 'token'
 *   },
 * });
 */
export function useResetPasswordMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ResetPasswordMutation, ResetPasswordMutationVariables>) {
        return ApolloReactHooks.useMutation<ResetPasswordMutation, ResetPasswordMutationVariables>(ResetPasswordDocument, baseOptions);
      }
export type ResetPasswordMutationHookResult = ReturnType<typeof useResetPasswordMutation>;
export type ResetPasswordMutationResult = ApolloReactCommon.MutationResult<ResetPasswordMutation>;
export type ResetPasswordMutationOptions = ApolloReactCommon.BaseMutationOptions<ResetPasswordMutation, ResetPasswordMutationVariables>;
export const CreatePasswordDocument = gql`
    mutation createPassword($accountID: String!, $userID: String!, $confirmPassword: String!, $password: String!) {
  createPassword(accountID: $accountID, userID: $userID, confirmPassword: $confirmPassword, password: $password)
}
    `;
export type CreatePasswordMutationFn = ApolloReactCommon.MutationFunction<CreatePasswordMutation, CreatePasswordMutationVariables>;

/**
 * __useCreatePasswordMutation__
 *
 * To run a mutation, you first call `useCreatePasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPasswordMutation, { data, loading, error }] = useCreatePasswordMutation({
 *   variables: {
 *      accountID: // value for 'accountID'
 *      userID: // value for 'userID'
 *      confirmPassword: // value for 'confirmPassword'
 *      password: // value for 'password'
 *   },
 * });
 */
export function useCreatePasswordMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreatePasswordMutation, CreatePasswordMutationVariables>) {
        return ApolloReactHooks.useMutation<CreatePasswordMutation, CreatePasswordMutationVariables>(CreatePasswordDocument, baseOptions);
      }
export type CreatePasswordMutationHookResult = ReturnType<typeof useCreatePasswordMutation>;
export type CreatePasswordMutationResult = ApolloReactCommon.MutationResult<CreatePasswordMutation>;
export type CreatePasswordMutationOptions = ApolloReactCommon.BaseMutationOptions<CreatePasswordMutation, CreatePasswordMutationVariables>;
export const ChangePwdUnblockUserDocument = gql`
    mutation changePwdUnblockUser($ID: String!, $password: String!, $confirmPassword: String!) {
  changePwdUnblockUser(ID: $ID, password: $password, confirmPassword: $confirmPassword)
}
    `;
export type ChangePwdUnblockUserMutationFn = ApolloReactCommon.MutationFunction<ChangePwdUnblockUserMutation, ChangePwdUnblockUserMutationVariables>;

/**
 * __useChangePwdUnblockUserMutation__
 *
 * To run a mutation, you first call `useChangePwdUnblockUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangePwdUnblockUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changePwdUnblockUserMutation, { data, loading, error }] = useChangePwdUnblockUserMutation({
 *   variables: {
 *      ID: // value for 'ID'
 *      password: // value for 'password'
 *      confirmPassword: // value for 'confirmPassword'
 *   },
 * });
 */
export function useChangePwdUnblockUserMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ChangePwdUnblockUserMutation, ChangePwdUnblockUserMutationVariables>) {
        return ApolloReactHooks.useMutation<ChangePwdUnblockUserMutation, ChangePwdUnblockUserMutationVariables>(ChangePwdUnblockUserDocument, baseOptions);
      }
export type ChangePwdUnblockUserMutationHookResult = ReturnType<typeof useChangePwdUnblockUserMutation>;
export type ChangePwdUnblockUserMutationResult = ApolloReactCommon.MutationResult<ChangePwdUnblockUserMutation>;
export type ChangePwdUnblockUserMutationOptions = ApolloReactCommon.BaseMutationOptions<ChangePwdUnblockUserMutation, ChangePwdUnblockUserMutationVariables>;
export const TwoFaTotpSecretToggleDocument = gql`
    mutation TwoFATotpSecretToggle($is2FAEnable: Boolean!) {
  TwoFATotpSecretToggle(is2FAEnable: $is2FAEnable)
}
    `;
export type TwoFaTotpSecretToggleMutationFn = ApolloReactCommon.MutationFunction<TwoFaTotpSecretToggleMutation, TwoFaTotpSecretToggleMutationVariables>;

/**
 * __useTwoFaTotpSecretToggleMutation__
 *
 * To run a mutation, you first call `useTwoFaTotpSecretToggleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTwoFaTotpSecretToggleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [twoFaTotpSecretToggleMutation, { data, loading, error }] = useTwoFaTotpSecretToggleMutation({
 *   variables: {
 *      is2FAEnable: // value for 'is2FAEnable'
 *   },
 * });
 */
export function useTwoFaTotpSecretToggleMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<TwoFaTotpSecretToggleMutation, TwoFaTotpSecretToggleMutationVariables>) {
        return ApolloReactHooks.useMutation<TwoFaTotpSecretToggleMutation, TwoFaTotpSecretToggleMutationVariables>(TwoFaTotpSecretToggleDocument, baseOptions);
      }
export type TwoFaTotpSecretToggleMutationHookResult = ReturnType<typeof useTwoFaTotpSecretToggleMutation>;
export type TwoFaTotpSecretToggleMutationResult = ApolloReactCommon.MutationResult<TwoFaTotpSecretToggleMutation>;
export type TwoFaTotpSecretToggleMutationOptions = ApolloReactCommon.BaseMutationOptions<TwoFaTotpSecretToggleMutation, TwoFaTotpSecretToggleMutationVariables>;
export const TwoFaTotpDetailsDocument = gql`
    query TwoFATotpDetails {
  TwoFATotpDetails {
    is2FA
    totpSecret
    dataURL
    otpURL
  }
}
    `;

/**
 * __useTwoFaTotpDetailsQuery__
 *
 * To run a query within a React component, call `useTwoFaTotpDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTwoFaTotpDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTwoFaTotpDetailsQuery({
 *   variables: {
 *   },
 * });
 */
export function useTwoFaTotpDetailsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<TwoFaTotpDetailsQuery, TwoFaTotpDetailsQueryVariables>) {
        return ApolloReactHooks.useQuery<TwoFaTotpDetailsQuery, TwoFaTotpDetailsQueryVariables>(TwoFaTotpDetailsDocument, baseOptions);
      }
export function useTwoFaTotpDetailsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TwoFaTotpDetailsQuery, TwoFaTotpDetailsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<TwoFaTotpDetailsQuery, TwoFaTotpDetailsQueryVariables>(TwoFaTotpDetailsDocument, baseOptions);
        }
export type TwoFaTotpDetailsQueryHookResult = ReturnType<typeof useTwoFaTotpDetailsQuery>;
export type TwoFaTotpDetailsLazyQueryHookResult = ReturnType<typeof useTwoFaTotpDetailsLazyQuery>;
export type TwoFaTotpDetailsQueryResult = ApolloReactCommon.QueryResult<TwoFaTotpDetailsQuery, TwoFaTotpDetailsQueryVariables>;
export const TotpValidateDocument = gql`
    mutation totpValidate($token: String!) {
  totpValidate(token: $token)
}
    `;
export type TotpValidateMutationFn = ApolloReactCommon.MutationFunction<TotpValidateMutation, TotpValidateMutationVariables>;

/**
 * __useTotpValidateMutation__
 *
 * To run a mutation, you first call `useTotpValidateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTotpValidateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [totpValidateMutation, { data, loading, error }] = useTotpValidateMutation({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function useTotpValidateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<TotpValidateMutation, TotpValidateMutationVariables>) {
        return ApolloReactHooks.useMutation<TotpValidateMutation, TotpValidateMutationVariables>(TotpValidateDocument, baseOptions);
      }
export type TotpValidateMutationHookResult = ReturnType<typeof useTotpValidateMutation>;
export type TotpValidateMutationResult = ApolloReactCommon.MutationResult<TotpValidateMutation>;
export type TotpValidateMutationOptions = ApolloReactCommon.BaseMutationOptions<TotpValidateMutation, TotpValidateMutationVariables>;
export const GetAllowedOriginDocument = gql`
    query getAllowedOrigin($ID: String, $productID: String, $origin: String, $orderByAsc: String) {
  getAllowedOrigin(ID: $ID, productID: $productID, origin: $origin, orderByAsc: $orderByAsc) {
    ID
    productID
    product {
      ID
      name
      code
      description
    }
    origin
    description
    commonStatus
  }
}
    `;

/**
 * __useGetAllowedOriginQuery__
 *
 * To run a query within a React component, call `useGetAllowedOriginQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllowedOriginQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllowedOriginQuery({
 *   variables: {
 *      ID: // value for 'ID'
 *      productID: // value for 'productID'
 *      origin: // value for 'origin'
 *      orderByAsc: // value for 'orderByAsc'
 *   },
 * });
 */
export function useGetAllowedOriginQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetAllowedOriginQuery, GetAllowedOriginQueryVariables>) {
        return ApolloReactHooks.useQuery<GetAllowedOriginQuery, GetAllowedOriginQueryVariables>(GetAllowedOriginDocument, baseOptions);
      }
export function useGetAllowedOriginLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetAllowedOriginQuery, GetAllowedOriginQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetAllowedOriginQuery, GetAllowedOriginQueryVariables>(GetAllowedOriginDocument, baseOptions);
        }
export type GetAllowedOriginQueryHookResult = ReturnType<typeof useGetAllowedOriginQuery>;
export type GetAllowedOriginLazyQueryHookResult = ReturnType<typeof useGetAllowedOriginLazyQuery>;
export type GetAllowedOriginQueryResult = ApolloReactCommon.QueryResult<GetAllowedOriginQuery, GetAllowedOriginQueryVariables>;
export const GetAllowedOriginNameDocument = gql`
    query getAllowedOriginName($ID: String, $productID: String, $origin: String, $orderByAsc: String) {
  getAllowedOrigin(ID: $ID, productID: $productID, origin: $origin, orderByAsc: $orderByAsc) {
    ID
    productID
    origin
    description
    commonStatus
  }
}
    `;

/**
 * __useGetAllowedOriginNameQuery__
 *
 * To run a query within a React component, call `useGetAllowedOriginNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllowedOriginNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllowedOriginNameQuery({
 *   variables: {
 *      ID: // value for 'ID'
 *      productID: // value for 'productID'
 *      origin: // value for 'origin'
 *      orderByAsc: // value for 'orderByAsc'
 *   },
 * });
 */
export function useGetAllowedOriginNameQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetAllowedOriginNameQuery, GetAllowedOriginNameQueryVariables>) {
        return ApolloReactHooks.useQuery<GetAllowedOriginNameQuery, GetAllowedOriginNameQueryVariables>(GetAllowedOriginNameDocument, baseOptions);
      }
export function useGetAllowedOriginNameLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetAllowedOriginNameQuery, GetAllowedOriginNameQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetAllowedOriginNameQuery, GetAllowedOriginNameQueryVariables>(GetAllowedOriginNameDocument, baseOptions);
        }
export type GetAllowedOriginNameQueryHookResult = ReturnType<typeof useGetAllowedOriginNameQuery>;
export type GetAllowedOriginNameLazyQueryHookResult = ReturnType<typeof useGetAllowedOriginNameLazyQuery>;
export type GetAllowedOriginNameQueryResult = ApolloReactCommon.QueryResult<GetAllowedOriginNameQuery, GetAllowedOriginNameQueryVariables>;
export const CreateAllowedOriginDocument = gql`
    mutation createAllowedOrigin($input: AllowedOriginInput!) {
  createAllowedOrigin(input: $input) {
    ID
    origin
    description
    commonStatus
  }
}
    `;
export type CreateAllowedOriginMutationFn = ApolloReactCommon.MutationFunction<CreateAllowedOriginMutation, CreateAllowedOriginMutationVariables>;

/**
 * __useCreateAllowedOriginMutation__
 *
 * To run a mutation, you first call `useCreateAllowedOriginMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAllowedOriginMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAllowedOriginMutation, { data, loading, error }] = useCreateAllowedOriginMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateAllowedOriginMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateAllowedOriginMutation, CreateAllowedOriginMutationVariables>) {
        return ApolloReactHooks.useMutation<CreateAllowedOriginMutation, CreateAllowedOriginMutationVariables>(CreateAllowedOriginDocument, baseOptions);
      }
export type CreateAllowedOriginMutationHookResult = ReturnType<typeof useCreateAllowedOriginMutation>;
export type CreateAllowedOriginMutationResult = ApolloReactCommon.MutationResult<CreateAllowedOriginMutation>;
export type CreateAllowedOriginMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateAllowedOriginMutation, CreateAllowedOriginMutationVariables>;
export const UpdateAllowedOriginDocument = gql`
    mutation updateAllowedOrigin($input: AllowedOriginInput!) {
  updateAllowedOrigin(input: $input) {
    origin
    description
    commonStatus
  }
}
    `;
export type UpdateAllowedOriginMutationFn = ApolloReactCommon.MutationFunction<UpdateAllowedOriginMutation, UpdateAllowedOriginMutationVariables>;

/**
 * __useUpdateAllowedOriginMutation__
 *
 * To run a mutation, you first call `useUpdateAllowedOriginMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAllowedOriginMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAllowedOriginMutation, { data, loading, error }] = useUpdateAllowedOriginMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAllowedOriginMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateAllowedOriginMutation, UpdateAllowedOriginMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdateAllowedOriginMutation, UpdateAllowedOriginMutationVariables>(UpdateAllowedOriginDocument, baseOptions);
      }
export type UpdateAllowedOriginMutationHookResult = ReturnType<typeof useUpdateAllowedOriginMutation>;
export type UpdateAllowedOriginMutationResult = ApolloReactCommon.MutationResult<UpdateAllowedOriginMutation>;
export type UpdateAllowedOriginMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateAllowedOriginMutation, UpdateAllowedOriginMutationVariables>;
export const DeleteAllowedOriginDocument = gql`
    mutation deleteAllowedOrigin($input: AllowedOriginDeleteInput!) {
  deleteAllowedOrigin(input: $input)
}
    `;
export type DeleteAllowedOriginMutationFn = ApolloReactCommon.MutationFunction<DeleteAllowedOriginMutation, DeleteAllowedOriginMutationVariables>;

/**
 * __useDeleteAllowedOriginMutation__
 *
 * To run a mutation, you first call `useDeleteAllowedOriginMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAllowedOriginMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAllowedOriginMutation, { data, loading, error }] = useDeleteAllowedOriginMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteAllowedOriginMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteAllowedOriginMutation, DeleteAllowedOriginMutationVariables>) {
        return ApolloReactHooks.useMutation<DeleteAllowedOriginMutation, DeleteAllowedOriginMutationVariables>(DeleteAllowedOriginDocument, baseOptions);
      }
export type DeleteAllowedOriginMutationHookResult = ReturnType<typeof useDeleteAllowedOriginMutation>;
export type DeleteAllowedOriginMutationResult = ApolloReactCommon.MutationResult<DeleteAllowedOriginMutation>;
export type DeleteAllowedOriginMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteAllowedOriginMutation, DeleteAllowedOriginMutationVariables>;
export const GetCurrencyDocument = gql`
    query getCurrency($ID: String, $orderByAsc: String) {
  getCurrency(ID: $ID, orderByAsc: $orderByAsc) {
    ID
    code
    name
    symbol
  }
}
    `;

/**
 * __useGetCurrencyQuery__
 *
 * To run a query within a React component, call `useGetCurrencyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCurrencyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCurrencyQuery({
 *   variables: {
 *      ID: // value for 'ID'
 *      orderByAsc: // value for 'orderByAsc'
 *   },
 * });
 */
export function useGetCurrencyQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetCurrencyQuery, GetCurrencyQueryVariables>) {
        return ApolloReactHooks.useQuery<GetCurrencyQuery, GetCurrencyQueryVariables>(GetCurrencyDocument, baseOptions);
      }
export function useGetCurrencyLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetCurrencyQuery, GetCurrencyQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetCurrencyQuery, GetCurrencyQueryVariables>(GetCurrencyDocument, baseOptions);
        }
export type GetCurrencyQueryHookResult = ReturnType<typeof useGetCurrencyQuery>;
export type GetCurrencyLazyQueryHookResult = ReturnType<typeof useGetCurrencyLazyQuery>;
export type GetCurrencyQueryResult = ApolloReactCommon.QueryResult<GetCurrencyQuery, GetCurrencyQueryVariables>;
export const UpdateCurrencyDocument = gql`
    mutation updateCurrency($input: CurrencyInput!) {
  updateCurrency(input: $input) {
    ID
    code
    name
    symbol
  }
}
    `;
export type UpdateCurrencyMutationFn = ApolloReactCommon.MutationFunction<UpdateCurrencyMutation, UpdateCurrencyMutationVariables>;

/**
 * __useUpdateCurrencyMutation__
 *
 * To run a mutation, you first call `useUpdateCurrencyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCurrencyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCurrencyMutation, { data, loading, error }] = useUpdateCurrencyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCurrencyMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateCurrencyMutation, UpdateCurrencyMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdateCurrencyMutation, UpdateCurrencyMutationVariables>(UpdateCurrencyDocument, baseOptions);
      }
export type UpdateCurrencyMutationHookResult = ReturnType<typeof useUpdateCurrencyMutation>;
export type UpdateCurrencyMutationResult = ApolloReactCommon.MutationResult<UpdateCurrencyMutation>;
export type UpdateCurrencyMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateCurrencyMutation, UpdateCurrencyMutationVariables>;
export const CreateCurrencyDocument = gql`
    mutation createCurrency($input: CurrencyInput!) {
  createCurrency(input: $input) {
    ID
    code
    name
    symbol
  }
}
    `;
export type CreateCurrencyMutationFn = ApolloReactCommon.MutationFunction<CreateCurrencyMutation, CreateCurrencyMutationVariables>;

/**
 * __useCreateCurrencyMutation__
 *
 * To run a mutation, you first call `useCreateCurrencyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCurrencyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCurrencyMutation, { data, loading, error }] = useCreateCurrencyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCurrencyMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateCurrencyMutation, CreateCurrencyMutationVariables>) {
        return ApolloReactHooks.useMutation<CreateCurrencyMutation, CreateCurrencyMutationVariables>(CreateCurrencyDocument, baseOptions);
      }
export type CreateCurrencyMutationHookResult = ReturnType<typeof useCreateCurrencyMutation>;
export type CreateCurrencyMutationResult = ApolloReactCommon.MutationResult<CreateCurrencyMutation>;
export type CreateCurrencyMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateCurrencyMutation, CreateCurrencyMutationVariables>;
export const DeleteCurrencyDocument = gql`
    mutation deleteCurrency($input: CurrencyDeleteInput!) {
  deleteCurrency(input: $input)
}
    `;
export type DeleteCurrencyMutationFn = ApolloReactCommon.MutationFunction<DeleteCurrencyMutation, DeleteCurrencyMutationVariables>;

/**
 * __useDeleteCurrencyMutation__
 *
 * To run a mutation, you first call `useDeleteCurrencyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCurrencyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCurrencyMutation, { data, loading, error }] = useDeleteCurrencyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteCurrencyMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteCurrencyMutation, DeleteCurrencyMutationVariables>) {
        return ApolloReactHooks.useMutation<DeleteCurrencyMutation, DeleteCurrencyMutationVariables>(DeleteCurrencyDocument, baseOptions);
      }
export type DeleteCurrencyMutationHookResult = ReturnType<typeof useDeleteCurrencyMutation>;
export type DeleteCurrencyMutationResult = ApolloReactCommon.MutationResult<DeleteCurrencyMutation>;
export type DeleteCurrencyMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteCurrencyMutation, DeleteCurrencyMutationVariables>;
export const GetCountryDocument = gql`
    query getCountry($ID: String) {
  getCountry(ID: $ID) {
    name
    ID
  }
}
    `;

/**
 * __useGetCountryQuery__
 *
 * To run a query within a React component, call `useGetCountryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCountryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCountryQuery({
 *   variables: {
 *      ID: // value for 'ID'
 *   },
 * });
 */
export function useGetCountryQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetCountryQuery, GetCountryQueryVariables>) {
        return ApolloReactHooks.useQuery<GetCountryQuery, GetCountryQueryVariables>(GetCountryDocument, baseOptions);
      }
export function useGetCountryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetCountryQuery, GetCountryQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetCountryQuery, GetCountryQueryVariables>(GetCountryDocument, baseOptions);
        }
export type GetCountryQueryHookResult = ReturnType<typeof useGetCountryQuery>;
export type GetCountryLazyQueryHookResult = ReturnType<typeof useGetCountryLazyQuery>;
export type GetCountryQueryResult = ApolloReactCommon.QueryResult<GetCountryQuery, GetCountryQueryVariables>;
export const GetStatebyCountryDocument = gql`
    query getStatebyCountry($countryID: String!) {
  getStatebyCountry(countryID: $countryID) {
    name
    ID
  }
}
    `;

/**
 * __useGetStatebyCountryQuery__
 *
 * To run a query within a React component, call `useGetStatebyCountryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStatebyCountryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStatebyCountryQuery({
 *   variables: {
 *      countryID: // value for 'countryID'
 *   },
 * });
 */
export function useGetStatebyCountryQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetStatebyCountryQuery, GetStatebyCountryQueryVariables>) {
        return ApolloReactHooks.useQuery<GetStatebyCountryQuery, GetStatebyCountryQueryVariables>(GetStatebyCountryDocument, baseOptions);
      }
export function useGetStatebyCountryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetStatebyCountryQuery, GetStatebyCountryQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetStatebyCountryQuery, GetStatebyCountryQueryVariables>(GetStatebyCountryDocument, baseOptions);
        }
export type GetStatebyCountryQueryHookResult = ReturnType<typeof useGetStatebyCountryQuery>;
export type GetStatebyCountryLazyQueryHookResult = ReturnType<typeof useGetStatebyCountryLazyQuery>;
export type GetStatebyCountryQueryResult = ApolloReactCommon.QueryResult<GetStatebyCountryQuery, GetStatebyCountryQueryVariables>;
export const GetCitybyStateDocument = gql`
    query getCitybyState($stateID: String!) {
  getCitybyState(stateID: $stateID) {
    ID
    name
  }
}
    `;

/**
 * __useGetCitybyStateQuery__
 *
 * To run a query within a React component, call `useGetCitybyStateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCitybyStateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCitybyStateQuery({
 *   variables: {
 *      stateID: // value for 'stateID'
 *   },
 * });
 */
export function useGetCitybyStateQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetCitybyStateQuery, GetCitybyStateQueryVariables>) {
        return ApolloReactHooks.useQuery<GetCitybyStateQuery, GetCitybyStateQueryVariables>(GetCitybyStateDocument, baseOptions);
      }
export function useGetCitybyStateLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetCitybyStateQuery, GetCitybyStateQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetCitybyStateQuery, GetCitybyStateQueryVariables>(GetCitybyStateDocument, baseOptions);
        }
export type GetCitybyStateQueryHookResult = ReturnType<typeof useGetCitybyStateQuery>;
export type GetCitybyStateLazyQueryHookResult = ReturnType<typeof useGetCitybyStateLazyQuery>;
export type GetCitybyStateQueryResult = ApolloReactCommon.QueryResult<GetCitybyStateQuery, GetCitybyStateQueryVariables>;
export const GetPostcodebyCityDocument = gql`
    query getPostcodebyCity($cityID: String!) {
  getPostcodebyCity(cityID: $cityID) {
    ID
    postcode
  }
}
    `;

/**
 * __useGetPostcodebyCityQuery__
 *
 * To run a query within a React component, call `useGetPostcodebyCityQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPostcodebyCityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPostcodebyCityQuery({
 *   variables: {
 *      cityID: // value for 'cityID'
 *   },
 * });
 */
export function useGetPostcodebyCityQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetPostcodebyCityQuery, GetPostcodebyCityQueryVariables>) {
        return ApolloReactHooks.useQuery<GetPostcodebyCityQuery, GetPostcodebyCityQueryVariables>(GetPostcodebyCityDocument, baseOptions);
      }
export function useGetPostcodebyCityLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetPostcodebyCityQuery, GetPostcodebyCityQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetPostcodebyCityQuery, GetPostcodebyCityQueryVariables>(GetPostcodebyCityDocument, baseOptions);
        }
export type GetPostcodebyCityQueryHookResult = ReturnType<typeof useGetPostcodebyCityQuery>;
export type GetPostcodebyCityLazyQueryHookResult = ReturnType<typeof useGetPostcodebyCityLazyQuery>;
export type GetPostcodebyCityQueryResult = ApolloReactCommon.QueryResult<GetPostcodebyCityQuery, GetPostcodebyCityQueryVariables>;
export const GetModuleDocument = gql`
    query getModule($ID: String, $productID: String, $name: String, $orderByAsc: String) {
  getModule(ID: $ID, productID: $productID, name: $name, orderByAsc: $orderByAsc) {
    ID
    productID
    product {
      ID
      name
      code
      description
    }
    name
    code
    sequence
    commonStatus
  }
}
    `;

/**
 * __useGetModuleQuery__
 *
 * To run a query within a React component, call `useGetModuleQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetModuleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetModuleQuery({
 *   variables: {
 *      ID: // value for 'ID'
 *      productID: // value for 'productID'
 *      name: // value for 'name'
 *      orderByAsc: // value for 'orderByAsc'
 *   },
 * });
 */
export function useGetModuleQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetModuleQuery, GetModuleQueryVariables>) {
        return ApolloReactHooks.useQuery<GetModuleQuery, GetModuleQueryVariables>(GetModuleDocument, baseOptions);
      }
export function useGetModuleLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetModuleQuery, GetModuleQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetModuleQuery, GetModuleQueryVariables>(GetModuleDocument, baseOptions);
        }
export type GetModuleQueryHookResult = ReturnType<typeof useGetModuleQuery>;
export type GetModuleLazyQueryHookResult = ReturnType<typeof useGetModuleLazyQuery>;
export type GetModuleQueryResult = ApolloReactCommon.QueryResult<GetModuleQuery, GetModuleQueryVariables>;
export const GetModuleNameDocument = gql`
    query getModuleName($ID: String, $productID: String, $name: String, $orderByAsc: String) {
  getModule(ID: $ID, productID: $productID, name: $name, orderByAsc: $orderByAsc) {
    ID
    productID
    name
    code
    sequence
    commonStatus
  }
}
    `;

/**
 * __useGetModuleNameQuery__
 *
 * To run a query within a React component, call `useGetModuleNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetModuleNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetModuleNameQuery({
 *   variables: {
 *      ID: // value for 'ID'
 *      productID: // value for 'productID'
 *      name: // value for 'name'
 *      orderByAsc: // value for 'orderByAsc'
 *   },
 * });
 */
export function useGetModuleNameQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetModuleNameQuery, GetModuleNameQueryVariables>) {
        return ApolloReactHooks.useQuery<GetModuleNameQuery, GetModuleNameQueryVariables>(GetModuleNameDocument, baseOptions);
      }
export function useGetModuleNameLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetModuleNameQuery, GetModuleNameQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetModuleNameQuery, GetModuleNameQueryVariables>(GetModuleNameDocument, baseOptions);
        }
export type GetModuleNameQueryHookResult = ReturnType<typeof useGetModuleNameQuery>;
export type GetModuleNameLazyQueryHookResult = ReturnType<typeof useGetModuleNameLazyQuery>;
export type GetModuleNameQueryResult = ApolloReactCommon.QueryResult<GetModuleNameQuery, GetModuleNameQueryVariables>;
export const CreateModuleDocument = gql`
    mutation createModule($input: ModuleInput!) {
  createModule(input: $input) {
    ID
    name
    code
    sequence
    commonStatus
  }
}
    `;
export type CreateModuleMutationFn = ApolloReactCommon.MutationFunction<CreateModuleMutation, CreateModuleMutationVariables>;

/**
 * __useCreateModuleMutation__
 *
 * To run a mutation, you first call `useCreateModuleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateModuleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createModuleMutation, { data, loading, error }] = useCreateModuleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateModuleMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateModuleMutation, CreateModuleMutationVariables>) {
        return ApolloReactHooks.useMutation<CreateModuleMutation, CreateModuleMutationVariables>(CreateModuleDocument, baseOptions);
      }
export type CreateModuleMutationHookResult = ReturnType<typeof useCreateModuleMutation>;
export type CreateModuleMutationResult = ApolloReactCommon.MutationResult<CreateModuleMutation>;
export type CreateModuleMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateModuleMutation, CreateModuleMutationVariables>;
export const UpdateModuleDocument = gql`
    mutation updateModule($input: ModuleInput!) {
  updateModule(input: $input) {
    name
    code
    sequence
    commonStatus
  }
}
    `;
export type UpdateModuleMutationFn = ApolloReactCommon.MutationFunction<UpdateModuleMutation, UpdateModuleMutationVariables>;

/**
 * __useUpdateModuleMutation__
 *
 * To run a mutation, you first call `useUpdateModuleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateModuleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateModuleMutation, { data, loading, error }] = useUpdateModuleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateModuleMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateModuleMutation, UpdateModuleMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdateModuleMutation, UpdateModuleMutationVariables>(UpdateModuleDocument, baseOptions);
      }
export type UpdateModuleMutationHookResult = ReturnType<typeof useUpdateModuleMutation>;
export type UpdateModuleMutationResult = ApolloReactCommon.MutationResult<UpdateModuleMutation>;
export type UpdateModuleMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateModuleMutation, UpdateModuleMutationVariables>;
export const DeleteModuleDocument = gql`
    mutation deleteModule($input: ModuleDeleteInput!) {
  deleteModule(input: $input)
}
    `;
export type DeleteModuleMutationFn = ApolloReactCommon.MutationFunction<DeleteModuleMutation, DeleteModuleMutationVariables>;

/**
 * __useDeleteModuleMutation__
 *
 * To run a mutation, you first call `useDeleteModuleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteModuleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteModuleMutation, { data, loading, error }] = useDeleteModuleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteModuleMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteModuleMutation, DeleteModuleMutationVariables>) {
        return ApolloReactHooks.useMutation<DeleteModuleMutation, DeleteModuleMutationVariables>(DeleteModuleDocument, baseOptions);
      }
export type DeleteModuleMutationHookResult = ReturnType<typeof useDeleteModuleMutation>;
export type DeleteModuleMutationResult = ApolloReactCommon.MutationResult<DeleteModuleMutation>;
export type DeleteModuleMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteModuleMutation, DeleteModuleMutationVariables>;
export const GetProductDocument = gql`
    query getProduct($ID: String, $name: String, $orderByAsc: String) {
  getProduct(ID: $ID, name: $name, orderByAsc: $orderByAsc) {
    ID
    name
    code
    description
  }
}
    `;

/**
 * __useGetProductQuery__
 *
 * To run a query within a React component, call `useGetProductQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProductQuery({
 *   variables: {
 *      ID: // value for 'ID'
 *      name: // value for 'name'
 *      orderByAsc: // value for 'orderByAsc'
 *   },
 * });
 */
export function useGetProductQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetProductQuery, GetProductQueryVariables>) {
        return ApolloReactHooks.useQuery<GetProductQuery, GetProductQueryVariables>(GetProductDocument, baseOptions);
      }
export function useGetProductLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetProductQuery, GetProductQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetProductQuery, GetProductQueryVariables>(GetProductDocument, baseOptions);
        }
export type GetProductQueryHookResult = ReturnType<typeof useGetProductQuery>;
export type GetProductLazyQueryHookResult = ReturnType<typeof useGetProductLazyQuery>;
export type GetProductQueryResult = ApolloReactCommon.QueryResult<GetProductQuery, GetProductQueryVariables>;
export const GetIfcaProductDocument = gql`
    query getIfcaProduct($ID: String, $name: String, $orderByAsc: String) {
  getIfcaProduct(ID: $ID, name: $name, orderByAsc: $orderByAsc) {
    ID
    name
    code
    description
  }
}
    `;

/**
 * __useGetIfcaProductQuery__
 *
 * To run a query within a React component, call `useGetIfcaProductQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIfcaProductQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetIfcaProductQuery({
 *   variables: {
 *      ID: // value for 'ID'
 *      name: // value for 'name'
 *      orderByAsc: // value for 'orderByAsc'
 *   },
 * });
 */
export function useGetIfcaProductQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetIfcaProductQuery, GetIfcaProductQueryVariables>) {
        return ApolloReactHooks.useQuery<GetIfcaProductQuery, GetIfcaProductQueryVariables>(GetIfcaProductDocument, baseOptions);
      }
export function useGetIfcaProductLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetIfcaProductQuery, GetIfcaProductQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetIfcaProductQuery, GetIfcaProductQueryVariables>(GetIfcaProductDocument, baseOptions);
        }
export type GetIfcaProductQueryHookResult = ReturnType<typeof useGetIfcaProductQuery>;
export type GetIfcaProductLazyQueryHookResult = ReturnType<typeof useGetIfcaProductLazyQuery>;
export type GetIfcaProductQueryResult = ApolloReactCommon.QueryResult<GetIfcaProductQuery, GetIfcaProductQueryVariables>;
export const CreateProductDocument = gql`
    mutation createProduct($input: ProductInput!) {
  createProduct(input: $input) {
    ID
  }
}
    `;
export type CreateProductMutationFn = ApolloReactCommon.MutationFunction<CreateProductMutation, CreateProductMutationVariables>;

/**
 * __useCreateProductMutation__
 *
 * To run a mutation, you first call `useCreateProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProductMutation, { data, loading, error }] = useCreateProductMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateProductMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateProductMutation, CreateProductMutationVariables>) {
        return ApolloReactHooks.useMutation<CreateProductMutation, CreateProductMutationVariables>(CreateProductDocument, baseOptions);
      }
export type CreateProductMutationHookResult = ReturnType<typeof useCreateProductMutation>;
export type CreateProductMutationResult = ApolloReactCommon.MutationResult<CreateProductMutation>;
export type CreateProductMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateProductMutation, CreateProductMutationVariables>;
export const UpdateProductDocument = gql`
    mutation updateProduct($input: ProductInput!) {
  updateProduct(input: $input) {
    ID
  }
}
    `;
export type UpdateProductMutationFn = ApolloReactCommon.MutationFunction<UpdateProductMutation, UpdateProductMutationVariables>;

/**
 * __useUpdateProductMutation__
 *
 * To run a mutation, you first call `useUpdateProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProductMutation, { data, loading, error }] = useUpdateProductMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateProductMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateProductMutation, UpdateProductMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdateProductMutation, UpdateProductMutationVariables>(UpdateProductDocument, baseOptions);
      }
export type UpdateProductMutationHookResult = ReturnType<typeof useUpdateProductMutation>;
export type UpdateProductMutationResult = ApolloReactCommon.MutationResult<UpdateProductMutation>;
export type UpdateProductMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateProductMutation, UpdateProductMutationVariables>;
export const DeleteProductDocument = gql`
    mutation deleteProduct($input: ProductDeleteInput!) {
  deleteProduct(input: $input)
}
    `;
export type DeleteProductMutationFn = ApolloReactCommon.MutationFunction<DeleteProductMutation, DeleteProductMutationVariables>;

/**
 * __useDeleteProductMutation__
 *
 * To run a mutation, you first call `useDeleteProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteProductMutation, { data, loading, error }] = useDeleteProductMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteProductMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteProductMutation, DeleteProductMutationVariables>) {
        return ApolloReactHooks.useMutation<DeleteProductMutation, DeleteProductMutationVariables>(DeleteProductDocument, baseOptions);
      }
export type DeleteProductMutationHookResult = ReturnType<typeof useDeleteProductMutation>;
export type DeleteProductMutationResult = ApolloReactCommon.MutationResult<DeleteProductMutation>;
export type DeleteProductMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteProductMutation, DeleteProductMutationVariables>;
export const DeclareSoftwareCodeEnumDocument = gql`
    query declareSoftwareCodeEnum($SoftwareCode: SoftwareCode!) {
  declareSoftwareCodeEnum(SoftwareCode: $SoftwareCode)
}
    `;

/**
 * __useDeclareSoftwareCodeEnumQuery__
 *
 * To run a query within a React component, call `useDeclareSoftwareCodeEnumQuery` and pass it any options that fit your needs.
 * When your component renders, `useDeclareSoftwareCodeEnumQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDeclareSoftwareCodeEnumQuery({
 *   variables: {
 *      SoftwareCode: // value for 'SoftwareCode'
 *   },
 * });
 */
export function useDeclareSoftwareCodeEnumQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<DeclareSoftwareCodeEnumQuery, DeclareSoftwareCodeEnumQueryVariables>) {
        return ApolloReactHooks.useQuery<DeclareSoftwareCodeEnumQuery, DeclareSoftwareCodeEnumQueryVariables>(DeclareSoftwareCodeEnumDocument, baseOptions);
      }
export function useDeclareSoftwareCodeEnumLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<DeclareSoftwareCodeEnumQuery, DeclareSoftwareCodeEnumQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<DeclareSoftwareCodeEnumQuery, DeclareSoftwareCodeEnumQueryVariables>(DeclareSoftwareCodeEnumDocument, baseOptions);
        }
export type DeclareSoftwareCodeEnumQueryHookResult = ReturnType<typeof useDeclareSoftwareCodeEnumQuery>;
export type DeclareSoftwareCodeEnumLazyQueryHookResult = ReturnType<typeof useDeclareSoftwareCodeEnumLazyQuery>;
export type DeclareSoftwareCodeEnumQueryResult = ApolloReactCommon.QueryResult<DeclareSoftwareCodeEnumQuery, DeclareSoftwareCodeEnumQueryVariables>;
export const DeclareSoftwarePackagesEnumDocument = gql`
    query declareSoftwarePackagesEnum($ContractPackage: ContractPackage!, $HotelPackage: HotelPackage!, $HRPackage: HRPackage!, $IfcaPackage: IfcaPackage!, $MenuPackages: MenuPackages!, $PropertyPackages: PropertyPackages!, $ReportDesignerPackage: ReportDesignerPackage!, $AccountPackage: AccountPackage!, $EinvoicePackages: EinvoicePackages!) {
  declareSoftwarePackagesEnum(ContractPackage: $ContractPackage, HotelPackage: $HotelPackage, HRPackage: $HRPackage, IfcaPackage: $IfcaPackage, MenuPackages: $MenuPackages, PropertyPackages: $PropertyPackages, ReportDesignerPackage: $ReportDesignerPackage, AccountPackage: $AccountPackage, EinvoicePackages: $EinvoicePackages)
}
    `;

/**
 * __useDeclareSoftwarePackagesEnumQuery__
 *
 * To run a query within a React component, call `useDeclareSoftwarePackagesEnumQuery` and pass it any options that fit your needs.
 * When your component renders, `useDeclareSoftwarePackagesEnumQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDeclareSoftwarePackagesEnumQuery({
 *   variables: {
 *      ContractPackage: // value for 'ContractPackage'
 *      HotelPackage: // value for 'HotelPackage'
 *      HRPackage: // value for 'HRPackage'
 *      IfcaPackage: // value for 'IfcaPackage'
 *      MenuPackages: // value for 'MenuPackages'
 *      PropertyPackages: // value for 'PropertyPackages'
 *      ReportDesignerPackage: // value for 'ReportDesignerPackage'
 *      AccountPackage: // value for 'AccountPackage'
 *      EinvoicePackages: // value for 'EinvoicePackages'
 *   },
 * });
 */
export function useDeclareSoftwarePackagesEnumQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<DeclareSoftwarePackagesEnumQuery, DeclareSoftwarePackagesEnumQueryVariables>) {
        return ApolloReactHooks.useQuery<DeclareSoftwarePackagesEnumQuery, DeclareSoftwarePackagesEnumQueryVariables>(DeclareSoftwarePackagesEnumDocument, baseOptions);
      }
export function useDeclareSoftwarePackagesEnumLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<DeclareSoftwarePackagesEnumQuery, DeclareSoftwarePackagesEnumQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<DeclareSoftwarePackagesEnumQuery, DeclareSoftwarePackagesEnumQueryVariables>(DeclareSoftwarePackagesEnumDocument, baseOptions);
        }
export type DeclareSoftwarePackagesEnumQueryHookResult = ReturnType<typeof useDeclareSoftwarePackagesEnumQuery>;
export type DeclareSoftwarePackagesEnumLazyQueryHookResult = ReturnType<typeof useDeclareSoftwarePackagesEnumLazyQuery>;
export type DeclareSoftwarePackagesEnumQueryResult = ApolloReactCommon.QueryResult<DeclareSoftwarePackagesEnumQuery, DeclareSoftwarePackagesEnumQueryVariables>;
export const GetAccountsBySoftwareCodeDocument = gql`
    query getAccountsBySoftwareCode($softwareCode: String!) {
  getAccountsBySoftwareCodeForUser(softwareCode: $softwareCode) {
    ID
    name
    code
    isInternal
    latestSubscription(softwareCode: $softwareCode)
  }
}
    `;

/**
 * __useGetAccountsBySoftwareCodeQuery__
 *
 * To run a query within a React component, call `useGetAccountsBySoftwareCodeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAccountsBySoftwareCodeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAccountsBySoftwareCodeQuery({
 *   variables: {
 *      softwareCode: // value for 'softwareCode'
 *   },
 * });
 */
export function useGetAccountsBySoftwareCodeQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetAccountsBySoftwareCodeQuery, GetAccountsBySoftwareCodeQueryVariables>) {
        return ApolloReactHooks.useQuery<GetAccountsBySoftwareCodeQuery, GetAccountsBySoftwareCodeQueryVariables>(GetAccountsBySoftwareCodeDocument, baseOptions);
      }
export function useGetAccountsBySoftwareCodeLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetAccountsBySoftwareCodeQuery, GetAccountsBySoftwareCodeQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetAccountsBySoftwareCodeQuery, GetAccountsBySoftwareCodeQueryVariables>(GetAccountsBySoftwareCodeDocument, baseOptions);
        }
export type GetAccountsBySoftwareCodeQueryHookResult = ReturnType<typeof useGetAccountsBySoftwareCodeQuery>;
export type GetAccountsBySoftwareCodeLazyQueryHookResult = ReturnType<typeof useGetAccountsBySoftwareCodeLazyQuery>;
export type GetAccountsBySoftwareCodeQueryResult = ApolloReactCommon.QueryResult<GetAccountsBySoftwareCodeQuery, GetAccountsBySoftwareCodeQueryVariables>;
export const GetProductInformationCenterDocument = gql`
    query getProductInformationCenter {
  getProductForUser {
    ID
    name
    code
    description
  }
}
    `;

/**
 * __useGetProductInformationCenterQuery__
 *
 * To run a query within a React component, call `useGetProductInformationCenterQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductInformationCenterQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProductInformationCenterQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetProductInformationCenterQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetProductInformationCenterQuery, GetProductInformationCenterQueryVariables>) {
        return ApolloReactHooks.useQuery<GetProductInformationCenterQuery, GetProductInformationCenterQueryVariables>(GetProductInformationCenterDocument, baseOptions);
      }
export function useGetProductInformationCenterLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetProductInformationCenterQuery, GetProductInformationCenterQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetProductInformationCenterQuery, GetProductInformationCenterQueryVariables>(GetProductInformationCenterDocument, baseOptions);
        }
export type GetProductInformationCenterQueryHookResult = ReturnType<typeof useGetProductInformationCenterQuery>;
export type GetProductInformationCenterLazyQueryHookResult = ReturnType<typeof useGetProductInformationCenterLazyQuery>;
export type GetProductInformationCenterQueryResult = ApolloReactCommon.QueryResult<GetProductInformationCenterQuery, GetProductInformationCenterQueryVariables>;
export const GetRoleListDocument = gql`
    query getRoleList {
  getRole {
    ID
    name
    commonStatus
  }
}
    `;

/**
 * __useGetRoleListQuery__
 *
 * To run a query within a React component, call `useGetRoleListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRoleListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRoleListQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetRoleListQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetRoleListQuery, GetRoleListQueryVariables>) {
        return ApolloReactHooks.useQuery<GetRoleListQuery, GetRoleListQueryVariables>(GetRoleListDocument, baseOptions);
      }
export function useGetRoleListLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetRoleListQuery, GetRoleListQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetRoleListQuery, GetRoleListQueryVariables>(GetRoleListDocument, baseOptions);
        }
export type GetRoleListQueryHookResult = ReturnType<typeof useGetRoleListQuery>;
export type GetRoleListLazyQueryHookResult = ReturnType<typeof useGetRoleListLazyQuery>;
export type GetRoleListQueryResult = ApolloReactCommon.QueryResult<GetRoleListQuery, GetRoleListQueryVariables>;
export const GetRoleByIdDocument = gql`
    query getRoleByID($ID: String!) {
  getRole(ID: $ID) {
    ID
    name
    commonStatus
    roleProduct {
      ID
      roleID
      productID
      productCode
    }
    roleAccount {
      ID
      roleID
      accountID
      account {
        name
        code
      }
    }
  }
}
    `;

/**
 * __useGetRoleByIdQuery__
 *
 * To run a query within a React component, call `useGetRoleByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRoleByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRoleByIdQuery({
 *   variables: {
 *      ID: // value for 'ID'
 *   },
 * });
 */
export function useGetRoleByIdQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetRoleByIdQuery, GetRoleByIdQueryVariables>) {
        return ApolloReactHooks.useQuery<GetRoleByIdQuery, GetRoleByIdQueryVariables>(GetRoleByIdDocument, baseOptions);
      }
export function useGetRoleByIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetRoleByIdQuery, GetRoleByIdQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetRoleByIdQuery, GetRoleByIdQueryVariables>(GetRoleByIdDocument, baseOptions);
        }
export type GetRoleByIdQueryHookResult = ReturnType<typeof useGetRoleByIdQuery>;
export type GetRoleByIdLazyQueryHookResult = ReturnType<typeof useGetRoleByIdLazyQuery>;
export type GetRoleByIdQueryResult = ApolloReactCommon.QueryResult<GetRoleByIdQuery, GetRoleByIdQueryVariables>;
export const GetRoleAccountDocument = gql`
    query getRoleAccount($roleID: String!) {
  getRoleAccount(roleID: $roleID) {
    ID
    roleID
    accountID
    account {
      name
      code
    }
  }
}
    `;

/**
 * __useGetRoleAccountQuery__
 *
 * To run a query within a React component, call `useGetRoleAccountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRoleAccountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRoleAccountQuery({
 *   variables: {
 *      roleID: // value for 'roleID'
 *   },
 * });
 */
export function useGetRoleAccountQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetRoleAccountQuery, GetRoleAccountQueryVariables>) {
        return ApolloReactHooks.useQuery<GetRoleAccountQuery, GetRoleAccountQueryVariables>(GetRoleAccountDocument, baseOptions);
      }
export function useGetRoleAccountLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetRoleAccountQuery, GetRoleAccountQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetRoleAccountQuery, GetRoleAccountQueryVariables>(GetRoleAccountDocument, baseOptions);
        }
export type GetRoleAccountQueryHookResult = ReturnType<typeof useGetRoleAccountQuery>;
export type GetRoleAccountLazyQueryHookResult = ReturnType<typeof useGetRoleAccountLazyQuery>;
export type GetRoleAccountQueryResult = ApolloReactCommon.QueryResult<GetRoleAccountQuery, GetRoleAccountQueryVariables>;
export const GetRoleProductDocument = gql`
    query getRoleProduct($roleID: String!) {
  getRoleProduct(roleID: $roleID) {
    ID
    roleID
    productID
    productCode
  }
}
    `;

/**
 * __useGetRoleProductQuery__
 *
 * To run a query within a React component, call `useGetRoleProductQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRoleProductQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRoleProductQuery({
 *   variables: {
 *      roleID: // value for 'roleID'
 *   },
 * });
 */
export function useGetRoleProductQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetRoleProductQuery, GetRoleProductQueryVariables>) {
        return ApolloReactHooks.useQuery<GetRoleProductQuery, GetRoleProductQueryVariables>(GetRoleProductDocument, baseOptions);
      }
export function useGetRoleProductLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetRoleProductQuery, GetRoleProductQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetRoleProductQuery, GetRoleProductQueryVariables>(GetRoleProductDocument, baseOptions);
        }
export type GetRoleProductQueryHookResult = ReturnType<typeof useGetRoleProductQuery>;
export type GetRoleProductLazyQueryHookResult = ReturnType<typeof useGetRoleProductLazyQuery>;
export type GetRoleProductQueryResult = ApolloReactCommon.QueryResult<GetRoleProductQuery, GetRoleProductQueryVariables>;
export const CreateRoleDocument = gql`
    mutation createRole($input: RoleInput!) {
  createRole(input: $input) {
    ID
  }
}
    `;
export type CreateRoleMutationFn = ApolloReactCommon.MutationFunction<CreateRoleMutation, CreateRoleMutationVariables>;

/**
 * __useCreateRoleMutation__
 *
 * To run a mutation, you first call `useCreateRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createRoleMutation, { data, loading, error }] = useCreateRoleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateRoleMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateRoleMutation, CreateRoleMutationVariables>) {
        return ApolloReactHooks.useMutation<CreateRoleMutation, CreateRoleMutationVariables>(CreateRoleDocument, baseOptions);
      }
export type CreateRoleMutationHookResult = ReturnType<typeof useCreateRoleMutation>;
export type CreateRoleMutationResult = ApolloReactCommon.MutationResult<CreateRoleMutation>;
export type CreateRoleMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateRoleMutation, CreateRoleMutationVariables>;
export const UpdateRoleDocument = gql`
    mutation updateRole($input: RoleInput!) {
  updateRole(input: $input) {
    ID
  }
}
    `;
export type UpdateRoleMutationFn = ApolloReactCommon.MutationFunction<UpdateRoleMutation, UpdateRoleMutationVariables>;

/**
 * __useUpdateRoleMutation__
 *
 * To run a mutation, you first call `useUpdateRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRoleMutation, { data, loading, error }] = useUpdateRoleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateRoleMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateRoleMutation, UpdateRoleMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdateRoleMutation, UpdateRoleMutationVariables>(UpdateRoleDocument, baseOptions);
      }
export type UpdateRoleMutationHookResult = ReturnType<typeof useUpdateRoleMutation>;
export type UpdateRoleMutationResult = ApolloReactCommon.MutationResult<UpdateRoleMutation>;
export type UpdateRoleMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateRoleMutation, UpdateRoleMutationVariables>;
export const DeleteRoleDocument = gql`
    mutation deleteRole($ID: String!) {
  deleteRole(ID: $ID)
}
    `;
export type DeleteRoleMutationFn = ApolloReactCommon.MutationFunction<DeleteRoleMutation, DeleteRoleMutationVariables>;

/**
 * __useDeleteRoleMutation__
 *
 * To run a mutation, you first call `useDeleteRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteRoleMutation, { data, loading, error }] = useDeleteRoleMutation({
 *   variables: {
 *      ID: // value for 'ID'
 *   },
 * });
 */
export function useDeleteRoleMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteRoleMutation, DeleteRoleMutationVariables>) {
        return ApolloReactHooks.useMutation<DeleteRoleMutation, DeleteRoleMutationVariables>(DeleteRoleDocument, baseOptions);
      }
export type DeleteRoleMutationHookResult = ReturnType<typeof useDeleteRoleMutation>;
export type DeleteRoleMutationResult = ApolloReactCommon.MutationResult<DeleteRoleMutation>;
export type DeleteRoleMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteRoleMutation, DeleteRoleMutationVariables>;
export const AssignRoleAccountDocument = gql`
    mutation assignRoleAccount($input: RoleAccountAssignmentInput!) {
  assignRoleAccount(input: $input)
}
    `;
export type AssignRoleAccountMutationFn = ApolloReactCommon.MutationFunction<AssignRoleAccountMutation, AssignRoleAccountMutationVariables>;

/**
 * __useAssignRoleAccountMutation__
 *
 * To run a mutation, you first call `useAssignRoleAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssignRoleAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assignRoleAccountMutation, { data, loading, error }] = useAssignRoleAccountMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAssignRoleAccountMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AssignRoleAccountMutation, AssignRoleAccountMutationVariables>) {
        return ApolloReactHooks.useMutation<AssignRoleAccountMutation, AssignRoleAccountMutationVariables>(AssignRoleAccountDocument, baseOptions);
      }
export type AssignRoleAccountMutationHookResult = ReturnType<typeof useAssignRoleAccountMutation>;
export type AssignRoleAccountMutationResult = ApolloReactCommon.MutationResult<AssignRoleAccountMutation>;
export type AssignRoleAccountMutationOptions = ApolloReactCommon.BaseMutationOptions<AssignRoleAccountMutation, AssignRoleAccountMutationVariables>;
export const UnAssignRoleAccountDocument = gql`
    mutation unAssignRoleAccount($input: RoleAccountAssignmentInput!) {
  unAssignRoleAccount(input: $input)
}
    `;
export type UnAssignRoleAccountMutationFn = ApolloReactCommon.MutationFunction<UnAssignRoleAccountMutation, UnAssignRoleAccountMutationVariables>;

/**
 * __useUnAssignRoleAccountMutation__
 *
 * To run a mutation, you first call `useUnAssignRoleAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnAssignRoleAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unAssignRoleAccountMutation, { data, loading, error }] = useUnAssignRoleAccountMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUnAssignRoleAccountMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UnAssignRoleAccountMutation, UnAssignRoleAccountMutationVariables>) {
        return ApolloReactHooks.useMutation<UnAssignRoleAccountMutation, UnAssignRoleAccountMutationVariables>(UnAssignRoleAccountDocument, baseOptions);
      }
export type UnAssignRoleAccountMutationHookResult = ReturnType<typeof useUnAssignRoleAccountMutation>;
export type UnAssignRoleAccountMutationResult = ApolloReactCommon.MutationResult<UnAssignRoleAccountMutation>;
export type UnAssignRoleAccountMutationOptions = ApolloReactCommon.BaseMutationOptions<UnAssignRoleAccountMutation, UnAssignRoleAccountMutationVariables>;
export const AssignRoleProductDocument = gql`
    mutation assignRoleProduct($input: RoleProductAssignmentInput!) {
  assignRoleProduct(input: $input)
}
    `;
export type AssignRoleProductMutationFn = ApolloReactCommon.MutationFunction<AssignRoleProductMutation, AssignRoleProductMutationVariables>;

/**
 * __useAssignRoleProductMutation__
 *
 * To run a mutation, you first call `useAssignRoleProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssignRoleProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assignRoleProductMutation, { data, loading, error }] = useAssignRoleProductMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAssignRoleProductMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AssignRoleProductMutation, AssignRoleProductMutationVariables>) {
        return ApolloReactHooks.useMutation<AssignRoleProductMutation, AssignRoleProductMutationVariables>(AssignRoleProductDocument, baseOptions);
      }
export type AssignRoleProductMutationHookResult = ReturnType<typeof useAssignRoleProductMutation>;
export type AssignRoleProductMutationResult = ApolloReactCommon.MutationResult<AssignRoleProductMutation>;
export type AssignRoleProductMutationOptions = ApolloReactCommon.BaseMutationOptions<AssignRoleProductMutation, AssignRoleProductMutationVariables>;
export const UnAssignRoleProductDocument = gql`
    mutation unAssignRoleProduct($input: RoleProductAssignmentInput!) {
  unAssignRoleProduct(input: $input)
}
    `;
export type UnAssignRoleProductMutationFn = ApolloReactCommon.MutationFunction<UnAssignRoleProductMutation, UnAssignRoleProductMutationVariables>;

/**
 * __useUnAssignRoleProductMutation__
 *
 * To run a mutation, you first call `useUnAssignRoleProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnAssignRoleProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unAssignRoleProductMutation, { data, loading, error }] = useUnAssignRoleProductMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUnAssignRoleProductMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UnAssignRoleProductMutation, UnAssignRoleProductMutationVariables>) {
        return ApolloReactHooks.useMutation<UnAssignRoleProductMutation, UnAssignRoleProductMutationVariables>(UnAssignRoleProductDocument, baseOptions);
      }
export type UnAssignRoleProductMutationHookResult = ReturnType<typeof useUnAssignRoleProductMutation>;
export type UnAssignRoleProductMutationResult = ApolloReactCommon.MutationResult<UnAssignRoleProductMutation>;
export type UnAssignRoleProductMutationOptions = ApolloReactCommon.BaseMutationOptions<UnAssignRoleProductMutation, UnAssignRoleProductMutationVariables>;
export const GetUserDocument = gql`
    query getUser($ID: String!) {
  getUser(ID: $ID) {
    ID
    name
    department
    email
    jobTitle
    contactNo
    superUser
    commonStatus
    userName
    roleID
  }
}
    `;

/**
 * __useGetUserQuery__
 *
 * To run a query within a React component, call `useGetUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserQuery({
 *   variables: {
 *      ID: // value for 'ID'
 *   },
 * });
 */
export function useGetUserQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetUserQuery, GetUserQueryVariables>) {
        return ApolloReactHooks.useQuery<GetUserQuery, GetUserQueryVariables>(GetUserDocument, baseOptions);
      }
export function useGetUserLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetUserQuery, GetUserQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetUserQuery, GetUserQueryVariables>(GetUserDocument, baseOptions);
        }
export type GetUserQueryHookResult = ReturnType<typeof useGetUserQuery>;
export type GetUserLazyQueryHookResult = ReturnType<typeof useGetUserLazyQuery>;
export type GetUserQueryResult = ApolloReactCommon.QueryResult<GetUserQuery, GetUserQueryVariables>;
export const GetUsersByAccountDocument = gql`
    query getUsersByAccount($accountID: String!, $status: CommonStatus) {
  getUsersByAccount(accountID: $accountID, status: $status) {
    ID
    userName
    email
    contactNo
    commonStatus
    confirmed
    avatar
    superUser
    accountID
    softwareCode
    name
    department
    jobTitle
    roleID
  }
}
    `;

/**
 * __useGetUsersByAccountQuery__
 *
 * To run a query within a React component, call `useGetUsersByAccountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUsersByAccountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUsersByAccountQuery({
 *   variables: {
 *      accountID: // value for 'accountID'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useGetUsersByAccountQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetUsersByAccountQuery, GetUsersByAccountQueryVariables>) {
        return ApolloReactHooks.useQuery<GetUsersByAccountQuery, GetUsersByAccountQueryVariables>(GetUsersByAccountDocument, baseOptions);
      }
export function useGetUsersByAccountLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetUsersByAccountQuery, GetUsersByAccountQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetUsersByAccountQuery, GetUsersByAccountQueryVariables>(GetUsersByAccountDocument, baseOptions);
        }
export type GetUsersByAccountQueryHookResult = ReturnType<typeof useGetUsersByAccountQuery>;
export type GetUsersByAccountLazyQueryHookResult = ReturnType<typeof useGetUsersByAccountLazyQuery>;
export type GetUsersByAccountQueryResult = ApolloReactCommon.QueryResult<GetUsersByAccountQuery, GetUsersByAccountQueryVariables>;
export const CreateUserDocument = gql`
    mutation createUser($input: UserInput!) {
  createUser(input: $input) {
    ID
    email
  }
}
    `;
export type CreateUserMutationFn = ApolloReactCommon.MutationFunction<CreateUserMutation, CreateUserMutationVariables>;

/**
 * __useCreateUserMutation__
 *
 * To run a mutation, you first call `useCreateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUserMutation, { data, loading, error }] = useCreateUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateUserMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateUserMutation, CreateUserMutationVariables>) {
        return ApolloReactHooks.useMutation<CreateUserMutation, CreateUserMutationVariables>(CreateUserDocument, baseOptions);
      }
export type CreateUserMutationHookResult = ReturnType<typeof useCreateUserMutation>;
export type CreateUserMutationResult = ApolloReactCommon.MutationResult<CreateUserMutation>;
export type CreateUserMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateUserMutation, CreateUserMutationVariables>;
export const UpdateUserDocument = gql`
    mutation updateUser($input: UserInput!) {
  updateUser(input: $input) {
    ID
  }
}
    `;
export type UpdateUserMutationFn = ApolloReactCommon.MutationFunction<UpdateUserMutation, UpdateUserMutationVariables>;

/**
 * __useUpdateUserMutation__
 *
 * To run a mutation, you first call `useUpdateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserMutation, { data, loading, error }] = useUpdateUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateUserMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateUserMutation, UpdateUserMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdateUserMutation, UpdateUserMutationVariables>(UpdateUserDocument, baseOptions);
      }
export type UpdateUserMutationHookResult = ReturnType<typeof useUpdateUserMutation>;
export type UpdateUserMutationResult = ApolloReactCommon.MutationResult<UpdateUserMutation>;
export type UpdateUserMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateUserMutation, UpdateUserMutationVariables>;